<template>
  <div class="p-2 sm:p-4 text-lexend overflow-x-hidden min-h-screen bg-gray-50 dark:bg-gray-900/50">
    <!-- Encabezado con Estilo Premium -->
    <div class="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3 sm:gap-4 mb-3 sm:mb-5 mt-1 scroll-reveal">
      <div class="animate-fadeIn w-full sm:w-auto">
        <div v-once class="flex items-center gap-2 mb-1">
          <div class="w-8 h-1 bg-indigo-600 rounded-full"></div>
          <span class="text-[10px] sm:text-xs font-black text-indigo-600 tracking-widest">Panel de Control</span>
        </div>
        <h1 class="text-xl sm:text-3xl font-black text-gray-900 dark:text-white tracking-tight flex items-center flex-wrap gap-2">
          Gestión de Reportes
          <span class="px-2 sm:px-3 py-0.5 bg-indigo-100 dark:bg-indigo-900/40 text-indigo-600 dark:text-indigo-300 text-xs sm:text-sm font-black rounded-lg border border-indigo-200 dark:border-indigo-800">
            {{ fechaSeleccionadaFormateada }}
          </span>
        </h1>
        <p v-once class="text-[10px] sm:text-xs text-gray-500 dark:text-gray-400 mt-0.5">Panel administrativo de inteligencia de negocio y resultados financieros</p>
      </div>
      
      <div class="flex flex-col sm:flex-row items-start sm:items-center gap-2 sm:gap-3 w-full sm:w-auto">
        <!-- CALENDARIO NATIVO HTML -->
        <div class="relative w-full sm:w-auto">
          <div class="flex items-center gap-2 px-3 sm:px-4 py-2 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-xl cursor-pointer hover:border-indigo-500 dark:hover:border-indigo-400 transition-all shadow-sm">
            <Icon icon="mdi:calendar-month" class="text-indigo-600 dark:text-indigo-400 text-lg flex-shrink-0" />
            <input 
              type="date" 
              v-model="fechaInput" 
              @change="cambiarFechaDesdeInput"
              class="bg-transparent border-none outline-none text-sm font-medium text-gray-700 dark:text-gray-300 w-[140px] sm:w-[160px] cursor-pointer"
              :max="fechaMaxima"
            />
          </div>
        </div>

        <!-- Botones rápidos de navegación -->
        <div class="flex gap-1">
          <button 
            @click="cambiarFecha(-1)" 
            class="p-2 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-xl hover:border-indigo-500 dark:hover:border-indigo-400 transition-all shadow-sm"
            title="Día anterior"
          >
            <Icon icon="mdi:chevron-left" class="text-gray-600 dark:text-gray-400 text-base" />
          </button>
          <button 
            @click="resetearFechaHoy" 
            class="px-2 sm:px-3 py-2 bg-indigo-100 dark:bg-indigo-900/40 text-indigo-600 dark:text-indigo-300 rounded-xl text-xs font-bold hover:bg-indigo-200 dark:hover:bg-indigo-800/50 transition-all shadow-sm whitespace-nowrap"
          >
            Hoy
          </button>
          <button 
            @click="cambiarFecha(1)" 
            class="p-2 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-xl hover:border-indigo-500 dark:hover:border-indigo-400 transition-all shadow-sm"
            title="Día siguiente"
          >
            <Icon icon="mdi:chevron-right" class="text-gray-600 dark:text-gray-400 text-base" />
          </button>
        </div>

        <!-- Botón Recordatorio Cashea (solo si es miércoles) -->
        <button v-if="esMiercoles" @click="abrirModalCasheaManual" class="px-3 sm:px-4 py-2 sm:py-3 bg-violet-100 hover:bg-violet-200 dark:bg-violet-900/40 dark:hover:bg-violet-800/60 text-violet-600 dark:text-violet-400 rounded-xl font-black text-[10px] sm:text-sm transition-all flex items-center gap-2 shadow-sm" title="Ver recordatorio Cashea">
          <Icon icon="mdi:lightning-bolt" class="text-base sm:text-xl" />
          <span class="hidden sm:inline">Cashea</span>
        </button>

        <!-- Botón Sincronizar -->
        <button @click="cargarEstadisticasPorFecha" class="px-3 sm:px-6 py-2 sm:py-3 bg-indigo-600 hover:bg-indigo-700 text-white rounded-xl font-black text-[10px] sm:text-sm tracking-widest transition-all shadow-lg shadow-indigo-500/20 flex items-center gap-2 w-full sm:w-auto justify-center" :disabled="cargandoStats">
          <Icon icon="mdi:refresh" :class="{'animate-spin': cargandoStats}" class="text-base sm:text-xl" />
          <span class="hidden sm:inline">{{ cargandoStats ? 'Cargando...' : 'Sincronizar Datos' }}</span>
          <span class="sm:hidden">{{ cargandoStats ? '...' : 'Actualizar' }}</span>
        </button>
      </div>
    </div>

    <!-- ============================================================ -->
    <!-- FILA DE TARJETAS - Orden: 1-11 -->
    <!-- ============================================================ -->
    <div class="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-4 gap-2 sm:gap-4 mb-3 sm:mb-6">
      
      <!-- 1. Card Servicios Taller Hoy -->
      <div class="relative overflow-hidden group bg-white dark:bg-gray-800 rounded-2xl sm:rounded-3xl p-3 sm:p-5 shadow-xl border border-gray-100 dark:border-gray-700 transition-all duration-300 hover:-translate-y-1 hover:shadow-2xl">
        <div class="absolute -right-4 -top-4 w-20 sm:w-24 h-20 sm:h-24 bg-purple-500/10 rounded-full blur-2xl group-hover:bg-purple-500/20 transition-colors"></div>
        <div class="flex items-start justify-between mb-2 sm:mb-3">
          <div class="p-2 sm:p-3 bg-purple-100 dark:bg-purple-900/40 rounded-xl sm:rounded-2xl text-purple-600 dark:text-purple-300">
            <Icon icon="mdi:tools" class="text-lg sm:text-2xl" />
          </div>
          <span v-once class="text-[8px] sm:text-[10px] font-bold px-1.5 sm:px-2 py-0.5 sm:py-1 bg-purple-50 dark:bg-purple-900/20 text-purple-600 dark:text-purple-400 rounded-lg">{{ fechaEtiqueta }}</span>
        </div>
        <h3 class="text-[10px] sm:text-xs text-gray-500 dark:text-gray-400 font-medium mb-0.5 sm:mb-1">Servicios Taller (USD)</h3>
        <p class="text-lg sm:text-2xl lg:text-3xl font-black text-gray-900 dark:text-white">${{ statsHoy.servicios.toFixed(2) }}</p>
        <div class="mt-2 sm:mt-3 flex items-center text-[8px] sm:text-[10px] text-purple-600 dark:text-purple-400 font-semibold cursor-pointer hover:underline" @click="$router.push('/pago-servicio')">
          Ver detalles <Icon icon="mdi:chevron-right" class="text-sm" />
        </div>
      </div>

      <!-- 2. Card Ventas Hoy -->
      <div class="relative overflow-hidden group bg-white dark:bg-gray-800 rounded-2xl sm:rounded-3xl p-3 sm:p-5 shadow-xl border border-gray-100 dark:border-gray-700 transition-all duration-300 hover:-translate-y-1 hover:shadow-2xl">
        <div class="absolute -right-4 -top-4 w-20 sm:w-24 h-20 sm:h-24 bg-blue-500/10 rounded-full blur-2xl group-hover:bg-blue-500/20 transition-colors"></div>
        <div class="flex items-start justify-between mb-2 sm:mb-3">
          <div class="p-2 sm:p-3 bg-blue-100 dark:bg-blue-900/40 rounded-xl sm:rounded-2xl text-blue-600 dark:text-blue-300">
            <Icon icon="mdi:cart-arrow-up" class="text-lg sm:text-2xl" />
          </div>
          <span v-once class="text-[8px] sm:text-[10px] font-bold px-1.5 sm:px-2 py-0.5 sm:py-1 bg-blue-50 dark:bg-blue-900/20 text-blue-600 dark:text-blue-400 rounded-lg">{{ fechaEtiqueta }}</span>
        </div>
        <h3 class="text-[10px] sm:text-xs text-gray-500 dark:text-gray-400 font-medium mb-0.5 sm:mb-1">Productos Totales (USD)</h3>
        <p class="text-lg sm:text-2xl lg:text-3xl font-black text-gray-900 dark:text-white">${{ statsHoy.ventas.toFixed(2) }}</p>
        <div class="mt-2 sm:mt-3 flex items-center text-[8px] sm:text-[10px] text-blue-600 dark:text-blue-400 font-semibold cursor-pointer hover:underline" @click="$router.push('/reporte-ventas')">
          Ver detalles <Icon icon="mdi:chevron-right" class="text-sm" />
        </div>
      </div>

      <!-- 3. Card Recepciones Express Hoy -->
      <div class="relative overflow-hidden group bg-white dark:bg-gray-800 rounded-2xl sm:rounded-3xl p-3 sm:p-5 shadow-xl border border-gray-100 dark:border-gray-700 transition-all duration-300 hover:-translate-y-1 hover:shadow-2xl">
        <div class="absolute -right-4 -top-4 w-20 sm:w-24 h-20 sm:h-24 bg-yellow-500/10 rounded-full blur-2xl group-hover:bg-yellow-500/20 transition-colors"></div>
        <div class="flex items-start justify-between mb-2 sm:mb-3">
          <div class="p-2 sm:p-3 bg-yellow-100 dark:bg-yellow-900/40 rounded-xl sm:rounded-2xl text-yellow-600 dark:text-yellow-300">
            <Icon icon="mdi:flash" class="text-lg sm:text-2xl" />
          </div>
          <span v-once class="text-[8px] sm:text-[10px] font-bold px-1.5 sm:px-2 py-0.5 sm:py-1 bg-yellow-50 dark:bg-yellow-900/20 text-yellow-600 dark:text-yellow-400 rounded-lg">{{ fechaEtiqueta }}</span>
        </div>
        <h3 class="text-[10px] sm:text-xs text-gray-500 dark:text-gray-400 font-medium mb-0.5 sm:mb-1">Recepciones Express (USD)</h3>
        <p class="text-lg sm:text-2xl lg:text-3xl font-black text-gray-900 dark:text-white">${{ statsHoy.recepcionesExpress.toFixed(2) }}</p>
        <div class="mt-2 sm:mt-3 flex items-center text-[8px] sm:text-[10px] text-yellow-600 dark:text-yellow-400 font-semibold cursor-pointer hover:underline" @click="$router.push('/diagnostico-express')">
          Ver detalles <Icon icon="mdi:chevron-right" class="text-sm" />
        </div>
      </div>

      <!-- 4. Card Servicios Externos Hoy -->
      <div class="relative overflow-hidden group bg-white dark:bg-gray-800 rounded-2xl sm:rounded-3xl p-3 sm:p-5 shadow-xl border border-gray-100 dark:border-gray-700 transition-all duration-300 hover:-translate-y-1 hover:shadow-2xl">
        <div class="absolute -right-4 -top-4 w-20 sm:w-24 h-20 sm:h-24 bg-cyan-500/10 rounded-full blur-2xl group-hover:bg-cyan-500/20 transition-colors"></div>
        <div class="flex items-start justify-between mb-2 sm:mb-3">
          <div class="p-2 sm:p-3 bg-cyan-100 dark:bg-cyan-900/40 rounded-xl sm:rounded-2xl text-cyan-600 dark:text-cyan-300">
          <Icon icon="mdi:home-outline" class="text-lg sm:text-2xl" />

          </div>
          <span v-once class="text-[8px] sm:text-[10px] font-bold px-1.5 sm:px-2 py-0.5 sm:py-1 bg-cyan-50 dark:bg-cyan-900/20 text-cyan-600 dark:text-cyan-400 rounded-lg">{{ fechaEtiqueta }}</span>
        </div>
        <h3 class="text-[10px] sm:text-xs text-gray-500 dark:text-gray-400 font-medium mb-0.5 sm:mb-1">Servicios Externos (USD)</h3>
        <p class="text-lg sm:text-2xl lg:text-3xl font-black text-gray-900 dark:text-white">${{ statsHoy.serviciosExternos.toFixed(2) }}</p>
        <div class="mt-2 sm:mt-3 flex items-center text-[8px] sm:text-[10px] text-cyan-600 dark:text-cyan-400 font-semibold cursor-pointer hover:underline" @click="$router.push('/servicios-externos')">
          Ver detalles <Icon icon="mdi:chevron-right" class="text-sm" />
        </div>
      </div>

      <!-- 5. Card Financiamiento Cashea Taller -->
      <div class="relative overflow-hidden group bg-white dark:bg-gray-800 rounded-2xl sm:rounded-3xl p-3 sm:p-5 shadow-xl border border-gray-100 dark:border-gray-700 transition-all duration-300 hover:-translate-y-1 hover:shadow-2xl">
        <div class="absolute -right-4 -top-4 w-20 sm:w-24 h-20 sm:h-24 bg-violet-500/10 rounded-full blur-2xl group-hover:bg-violet-500/20 transition-colors"></div>
        <div class="flex items-start justify-between mb-2 sm:mb-3">
          <div class="p-2 sm:p-3 bg-violet-100 dark:bg-violet-900/40 rounded-xl sm:rounded-2xl text-violet-600 dark:text-violet-300">
            <Icon icon="mdi:lightning-bolt" class="text-lg sm:text-2xl" />
          </div>
          <span v-once class="text-[8px] sm:text-[10px] font-bold px-1.5 sm:px-2 py-0.5 sm:py-1 bg-violet-50 dark:bg-violet-900/20 text-violet-600 dark:text-violet-400 rounded-lg">{{ fechaEtiqueta }}</span>
        </div>
        <h3 class="text-[10px] sm:text-xs text-gray-500 dark:text-gray-400 font-medium mb-0.5 sm:mb-1">Cashea (Servicios)</h3>
        <p class="text-lg sm:text-2xl lg:text-3xl font-black text-gray-900 dark:text-white">${{ metodosServicios['Crédito Cashea'].toFixed(2) }}</p>
        <div class="mt-2 sm:mt-3 flex items-center text-[8px] sm:text-[10px] text-violet-600 dark:text-violet-400 font-semibold cursor-pointer hover:underline" @click="$router.push('/pago-servicio')">
          Ver cuotas <Icon icon="mdi:chevron-right" class="text-sm" />
        </div>
      </div>

      <!-- 6. Card Crédito Cashea (Ventas) -->
      <div class="relative overflow-hidden group bg-white dark:bg-gray-800 rounded-2xl sm:rounded-3xl p-3 sm:p-5 shadow-xl border border-gray-100 dark:border-gray-700 transition-all duration-300 hover:-translate-y-1 hover:shadow-2xl">
        <div class="absolute -right-4 -top-4 w-20 sm:w-24 h-20 sm:h-24 bg-violet-500/10 rounded-full blur-2xl group-hover:bg-violet-500/20 transition-colors"></div>
        <div class="flex items-start justify-between mb-2 sm:mb-3">
          <div class="p-2 sm:p-3 bg-violet-100 dark:bg-violet-900/40 rounded-xl sm:rounded-2xl text-violet-600 dark:text-violet-300">
            <Icon icon="mdi:lightning-bolt" class="text-lg sm:text-2xl" />
          </div>
          <span v-once class="text-[8px] sm:text-[10px] font-bold px-1.5 sm:px-2 py-0.5 sm:py-1 bg-violet-50 dark:bg-violet-900/20 text-violet-600 dark:text-violet-400 rounded-lg">{{ fechaEtiqueta }}</span>
        </div>
        <h3 class="text-[10px] sm:text-xs text-gray-500 dark:text-gray-400 font-medium mb-0.5 sm:mb-1">Cashea (Ventas)</h3>
        <p class="text-lg sm:text-2xl lg:text-3xl font-black text-gray-900 dark:text-white">${{ metodosVentas['Crédito Cashea'].toFixed(2) }}</p>
        <div class="mt-2 sm:mt-3 flex items-center text-[8px] sm:text-[10px] text-violet-600 dark:text-violet-400 font-semibold cursor-pointer hover:underline" @click="$router.push('/reporte-ventas')">
          Ver detalles <Icon icon="mdi:chevron-right" class="text-sm" />
        </div>
      </div>

      <!-- 7. Card Financiamiento Empresarial Taller -->
      <div class="relative overflow-hidden group bg-white dark:bg-gray-800 rounded-2xl sm:rounded-3xl p-3 sm:p-5 shadow-xl border border-gray-100 dark:border-gray-700 transition-all duration-300 hover:-translate-y-1 hover:shadow-2xl">
        <div class="absolute -right-4 -top-4 w-20 sm:w-24 h-20 sm:h-24 bg-orange-500/10 rounded-full blur-2xl group-hover:bg-orange-500/20 transition-colors"></div>
        <div class="flex items-start justify-between mb-2 sm:mb-3">
          <div class="p-2 sm:p-3 bg-orange-100 dark:bg-orange-900/40 rounded-xl sm:rounded-2xl text-orange-600 dark:text-orange-300">
            <Icon icon="mdi:domain" class="text-lg sm:text-2xl" />
          </div>
          <span v-once class="text-[8px] sm:text-[10px] font-bold px-1.5 sm:px-2 py-0.5 sm:py-1 bg-orange-50 dark:bg-orange-900/20 text-orange-600 dark:text-orange-400 rounded-lg">{{ fechaEtiqueta }}</span>
        </div>
        <h3 class="text-[10px] sm:text-xs text-gray-500 dark:text-gray-400 font-medium mb-0.5 sm:mb-1">Crédito Empresarial (Servicios)</h3>
        <p class="text-lg sm:text-2xl lg:text-3xl font-black text-gray-900 dark:text-white">${{ metodosServicios['Crédito Empresarial'].toFixed(2) }}</p>
        <div class="mt-2 sm:mt-3 flex items-center text-[8px] sm:text-[10px] text-orange-600 dark:text-orange-400 font-semibold cursor-pointer hover:underline" @click="$router.push('/pago-servicio')">
          Ver cuotas <Icon icon="mdi:chevron-right" class="text-sm" />
        </div>
      </div>

      <!-- 8. Card Crédito Empresarial (Ventas) -->
      <div class="relative overflow-hidden group bg-white dark:bg-gray-800 rounded-2xl sm:rounded-3xl p-3 sm:p-5 shadow-xl border border-gray-100 dark:border-gray-700 transition-all duration-300 hover:-translate-y-1 hover:shadow-2xl">
        <div class="absolute -right-4 -top-4 w-20 sm:w-24 h-20 sm:h-24 bg-orange-500/10 rounded-full blur-2xl group-hover:bg-orange-500/20 transition-colors"></div>
        <div class="flex items-start justify-between mb-2 sm:mb-3">
          <div class="p-2 sm:p-3 bg-orange-100 dark:bg-orange-900/40 rounded-xl sm:rounded-2xl text-orange-600 dark:text-orange-300">
            <Icon icon="mdi:domain" class="text-lg sm:text-2xl" />
          </div>
          <span v-once class="text-[8px] sm:text-[10px] font-bold px-1.5 sm:px-2 py-0.5 sm:py-1 bg-orange-50 dark:bg-orange-900/20 text-orange-600 dark:text-orange-400 rounded-lg">{{ fechaEtiqueta }}</span>
        </div>
        <h3 class="text-[10px] sm:text-xs text-gray-500 dark:text-gray-400 font-medium mb-0.5 sm:mb-1">Crédito Empresarial (Ventas)</h3>
        <p class="text-lg sm:text-2xl lg:text-3xl font-black text-gray-900 dark:text-white">${{ metodosVentas['Crédito Empresarial'].toFixed(2) }}</p>
        <div class="mt-2 sm:mt-3 flex items-center text-[8px] sm:text-[10px] text-orange-600 dark:text-orange-400 font-semibold cursor-pointer hover:underline" @click="$router.push('/reporte-ventas')">
          Ver detalles <Icon icon="mdi:chevron-right" class="text-sm" />
        </div>
      </div>

      <!-- 9. Card Créditos Servicios Externos (FIADO) -->
      <div class="relative overflow-hidden group bg-gradient-to-br from-amber-500 to-orange-600 rounded-2xl sm:rounded-3xl p-3 sm:p-5 shadow-xl transition-all duration-300 hover:-translate-y-1 hover:shadow-orange-500/30">
        <div class="absolute right-0 bottom-0 opacity-10">
          <Icon icon="mdi:receipt-outline" class="text-6xl sm:text-8xl" />
        </div>
        <div class="flex items-start justify-between mb-2 sm:mb-3">
          <div class="p-2 sm:p-3 bg-white/20 backdrop-blur-md rounded-xl sm:rounded-2xl text-white">
            <Icon icon="mdi:home-wrench" class="text-lg sm:text-2xl" />
          </div>
          <span v-once class="text-[8px] sm:text-[10px] font-bold px-1.5 sm:px-2 py-0.5 sm:py-1 bg-white/20 text-white rounded-lg">FIADO</span>
        </div>
        <h3 class="text-[10px] sm:text-xs text-amber-100/80 font-medium mb-0.5 sm:mb-1">Créditos Servicios Externos</h3>
        <p class="text-lg sm:text-2xl lg:text-3xl font-black text-white">${{ totalCreditosServiciosExternos.toFixed(2) }}</p>
        <div class="mt-2 sm:mt-3 flex flex-col text-[8px] sm:text-[10px] text-white/80 font-bold">
          <span><Icon icon="mdi:lightning-bolt" class="inline mr-1" /> Cashea: ${{ totalCreditosCasheaExternos.toFixed(2) }}</span>
          <span><Icon icon="mdi:domain" class="inline mr-1" /> Empresarial: ${{ totalCreditosEmpresarialExternos.toFixed(2) }}</span>
        </div>
      </div>

      <!-- 10. Card Operaciones Realizadas -->
      <div class="relative overflow-hidden group bg-white dark:bg-gray-800 rounded-2xl sm:rounded-3xl p-3 sm:p-5 shadow-xl border border-gray-100 dark:border-gray-700 transition-all duration-300 hover:-translate-y-1 hover:shadow-2xl">
        <div class="absolute -right-4 -top-4 w-20 sm:w-24 h-20 sm:h-24 bg-emerald-500/10 rounded-full blur-2xl group-hover:bg-emerald-500/20 transition-colors"></div>
        <div class="flex items-start justify-between mb-2 sm:mb-3">
          <div class="p-2 sm:p-3 bg-emerald-100 dark:bg-emerald-900/40 rounded-xl sm:rounded-2xl text-emerald-600 dark:text-emerald-300">
            <Icon icon="mdi:account-group" class="text-lg sm:text-2xl" />
          </div>
        </div>
        <h3 class="text-[10px] sm:text-xs text-gray-500 dark:text-gray-400 font-medium mb-0.5 sm:mb-1">Operaciones Realizadas</h3>
        <p class="text-lg sm:text-2xl lg:text-3xl font-black text-gray-900 dark:text-white">{{ statsHoy.conteo }}</p>
        <div class="mt-2 sm:mt-3 flex items-center text-[8px] sm:text-[10px] text-emerald-600 dark:text-emerald-400 font-bold">
          Ventas + Servicios realizados {{ fechaEtiqueta.toLowerCase() }}
        </div>
      </div>

      <!-- 11. Card Total Combinado (COBRO REAL) -->
      <div class="relative overflow-hidden group bg-gradient-to-br from-indigo-600 to-blue-700 rounded-2xl sm:rounded-3xl p-3 sm:p-5 shadow-xl transition-all duration-300 hover:-translate-y-1 hover:shadow-blue-500/30">
        <div class="absolute right-0 bottom-0 opacity-10">
          <Icon icon="mdi:bank" class="text-6xl sm:text-8xl" />
        </div>
        <div class="flex items-start justify-between mb-2 sm:mb-3">
          <div class="p-2 sm:p-3 bg-white/20 backdrop-blur-md rounded-xl sm:rounded-2xl text-white">
            <Icon icon="mdi:cash-multiple" class="text-lg sm:text-2xl" />
          </div>
          <span v-once class="text-[8px] sm:text-[10px] font-bold px-1.5 sm:px-2 py-0.5 sm:py-1 bg-white/20 text-white rounded-lg">COBRO REAL</span>
        </div>
        <h3 class="text-[10px] sm:text-xs text-indigo-100/80 font-medium mb-0.5 sm:mb-1">Ingreso Diario Cobrado</h3>
        <p class="text-lg sm:text-2xl lg:text-3xl font-black text-white">${{ totalDiario.toFixed(2) }}</p>
        <div class="mt-2 sm:mt-3 flex items-center text-[8px] sm:text-[10px] text-white/90 font-bold">
          <Icon icon="mdi:trending-up" class="mr-1" /> Total cobrado {{ fechaEtiqueta.toLowerCase() }} (sin créditos)
        </div>
      </div>
    </div>

    <!-- ============================================================ -->
    <!-- REGISTRO DIARIO DE SERVICIOS (CON TRANSACCIONES) -->
    <!-- ============================================================ -->
    <div class="bg-white dark:bg-gray-800 rounded-2xl sm:rounded-3xl p-3 sm:p-5 shadow-xl border border-gray-100 dark:border-gray-700 mb-4 sm:mb-6 transition-all duration-300">
      <div class="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3 sm:gap-4 mb-4 sm:mb-6">
        <div>
          <h2 class="text-base sm:text-xl font-bold text-gray-800 dark:text-white flex items-center">
            <Icon icon="mdi:clipboard-list" class="mr-2 text-purple-600" />
            Registro Diario de Servicios
          </h2>
          <p class="text-[10px] sm:text-sm text-gray-500 dark:text-gray-400 mt-0.5">
            <span class="font-bold text-purple-600">{{ serviciosDiarios.length }}</span> servicios registrados {{ fechaEtiqueta.toLowerCase() }}
            <span class="text-gray-400 ml-2">(todos los estados)</span>
          </p>
        </div>
        <div class="text-right bg-purple-50 dark:bg-purple-900/20 border border-purple-100 dark:border-purple-800/30 rounded-xl sm:rounded-2xl px-3 sm:px-5 py-2 sm:py-3 w-full sm:w-auto">
          <p class="text-[8px] sm:text-[10px] text-purple-500 uppercase font-bold tracking-wider">Total Cobrado</p>
          <p class="text-base sm:text-2xl font-black text-purple-600 dark:text-purple-400">${{ totalServiciosCobrado.toFixed(2) }}</p>
          <p class="text-[8px] sm:text-[10px] text-purple-400 font-medium" v-if="tasaUbcv">Bs. {{ (totalServiciosCobrado * tasaUbcv).toLocaleString('es-VE', {minimumFractionDigits: 2, maximumFractionDigits: 2}) }}</p>
        </div>
      </div>

      <!-- Filtros rápidos -->
      <div class="flex flex-wrap gap-2 mb-4">
        <button 
          @click="filtroEstadoServicios = 'todos'; paginaActual = 1"
          class="px-3 py-1.5 text-xs font-bold rounded-full transition-all"
          :class="filtroEstadoServicios === 'todos' ? 'bg-purple-600 text-white' : 'bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-400 hover:bg-gray-200 dark:hover:bg-gray-600'"
        >
          Todos ({{ serviciosDiarios.length }})
        </button>
        <button 
          @click="filtroEstadoServicios = 'completado'; paginaActual = 1"
          class="px-3 py-1.5 text-xs font-bold rounded-full transition-all"
          :class="filtroEstadoServicios === 'completado' ? 'bg-emerald-600 text-white' : 'bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-400 hover:bg-gray-200 dark:hover:bg-gray-600'"
        >
          ✅ Completados ({{ serviciosCompletados.length }})
        </button>
        <button 
          @click="filtroEstadoServicios = 'pendiente'; paginaActual = 1"
          class="px-3 py-1.5 text-xs font-bold rounded-full transition-all"
          :class="filtroEstadoServicios === 'pendiente' ? 'bg-yellow-600 text-white' : 'bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-400 hover:bg-gray-200 dark:hover:bg-gray-600'"
        >
          ⏳ Pendientes ({{ serviciosPendientes.length }})
        </button>
        <button 
          @click="filtroEstadoServicios = 'externos'; paginaActual = 1"
          class="px-3 py-1.5 text-xs font-bold rounded-full transition-all"
          :class="filtroEstadoServicios === 'externos' ? 'bg-cyan-600 text-white' : 'bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-400 hover:bg-gray-200 dark:hover:bg-gray-600'"
        >
          🔧 Externos ({{ serviciosExternosFiltrados.length }})
        </button>
      </div>

      <!-- Tabla de servicios del día con paginación y TRANSACCIONES -->
      <div class="overflow-x-auto">
        <table class="w-full text-left text-[10px] sm:text-sm">
          <thead>
            <tr class="border-b border-gray-200 dark:border-gray-700">
              <th class="pb-2 sm:pb-3 font-bold text-gray-500 dark:text-gray-400 uppercase tracking-wider">#</th>
              <th class="pb-2 sm:pb-3 font-bold text-gray-500 dark:text-gray-400 uppercase tracking-wider">Tipo</th>
              <th class="pb-2 sm:pb-3 font-bold text-gray-500 dark:text-gray-400 uppercase tracking-wider">Cliente</th>
              <th class="pb-2 sm:pb-3 font-bold text-gray-500 dark:text-gray-400 uppercase tracking-wider">Método Pago</th>
              <th class="pb-2 sm:pb-3 font-bold text-gray-500 dark:text-gray-400 uppercase tracking-wider text-right">Monto USD</th>
              <th class="pb-2 sm:pb-3 font-bold text-gray-500 dark:text-gray-400 uppercase tracking-wider text-right">Cobrado {{ fechaEtiqueta }}</th>
              <th class="pb-2 sm:pb-3 font-bold text-gray-500 dark:text-gray-400 uppercase tracking-wider text-right">Financiado</th>
              <th class="pb-2 sm:pb-3 font-bold text-gray-500 dark:text-gray-400 uppercase tracking-wider">Estado</th>
              <th class="pb-2 sm:pb-3 font-bold text-gray-500 dark:text-gray-400 uppercase tracking-wider">Fecha</th>
              <th class="pb-2 sm:pb-3 font-bold text-gray-500 dark:text-gray-400 uppercase tracking-wider">Transacciones</th>
            </tr>
          </thead>
          <tbody>
            <tr 
              v-for="(servicio, index) in serviciosPaginados" 
              :key="servicio.id || servicio.idRecepcionEquipo || servicio.numeroOrden || index"
              class="border-b border-gray-100 dark:border-gray-700/50 hover:bg-gray-50 dark:hover:bg-gray-700/20 transition-colors"
              :class="{'opacity-60': !servicio.estadoCompletado}"
            >
              <td class="py-2 sm:py-3 font-bold text-gray-800 dark:text-white">
                <button 
                  @click="$router.push(`/seguimiento/${servicio.numeroOrden || servicio.idRecepcionEquipo || servicio.id}`)"
                  class="hover:text-indigo-600 dark:hover:text-indigo-400 hover:underline transition-all font-bold flex items-center gap-1 bg-transparent border-none p-0 cursor-pointer group"
                  :title="`Ver detalles de la orden #${servicio.numeroOrden || servicio.idRecepcionEquipo || servicio.id}`"
                >
                  #{{ servicio.numeroOrden || servicio.idRecepcionEquipo || servicio.id || 'N/A' }}
                  <Icon icon="mdi:arrow-right-circle" class="text-xs opacity-0 group-hover:opacity-100 transition-opacity text-indigo-500" />
                </button>
              </td>
              <td class="py-2 sm:py-3">
                <span class="px-2 py-0.5 rounded-full text-[8px] sm:text-[10px] font-bold" :class="servicio.tipo === 'externo' ? 'bg-cyan-100 text-cyan-700 dark:bg-cyan-900/30 dark:text-cyan-400' : 'bg-purple-100 text-purple-700 dark:bg-purple-900/30 dark:text-purple-400'">
                  {{ servicio.tipo === 'externo' ? 'Externo' : 'Taller' }}
                </span>
              </td>
              <td class="py-2 sm:py-3 text-gray-700 dark:text-gray-300">
                {{ servicio.clienteNombre || servicio.cliente || 'Cliente' }}
              </td>
              <td class="py-2 sm:py-3">
                <span class="px-2 py-0.5 rounded-full text-[8px] sm:text-[10px] font-bold" :class="getMetodoPagoClass(servicio.metodoPago)">
                  {{ servicio.metodoPago || 'Efectivo' }}
                </span>
              </td>
              <td class="py-2 sm:py-3 text-right font-bold text-gray-800 dark:text-white">
                ${{ (servicio.totalServicio || servicio.montoCobradoUsd || 0).toFixed(2) }}
              </td>
              <td class="py-2 sm:py-3 text-right font-bold text-emerald-600 dark:text-emerald-400">
                ${{ (servicio.montoCobradoUsd || 0).toFixed(2) }}
              </td>
              <td class="py-2 sm:py-3 text-right">
                <span v-if="servicio.financiado > 0" class="text-orange-600 dark:text-orange-400 font-bold">
                  ${{ servicio.financiado.toFixed(2) }}
                </span>
                <span v-else class="text-gray-400">—</span>
              </td>
              <td class="py-2 sm:py-3">
                <span class="px-2 py-0.5 rounded-full text-[8px] sm:text-[10px] font-bold" :class="getEstadoClass(servicio.estado)">
                  {{ servicio.estado || 'Pendiente' }}
                </span>
              </td>
              <td class="py-2 sm:py-3 text-gray-500 dark:text-gray-400 text-[10px]">
                {{ servicio.fechaIngreso ? formatFecha(servicio.fechaIngreso) : '—' }}
              </td>
              <td class="py-2 sm:py-3">
                <div v-if="servicio.transacciones && servicio.transacciones.length > 0" class="space-y-1">
                  <div v-for="(pago, idx) in servicio.transacciones" :key="idx" class="text-[8px] sm:text-[10px] border-b border-gray-100 dark:border-gray-700/50 pb-1 last:border-0">
                    <span class="font-medium text-gray-600 dark:text-gray-400">{{ pago.metodo || 'N/A' }}</span>
                    <span class="font-bold text-emerald-600 dark:text-emerald-400"> ${{ (pago.monto || 0).toFixed(2) }}</span>
                    <span class="text-gray-400 text-[7px] sm:text-[9px] ml-1">{{ pago.fecha ? formatFechaHora(pago.fecha) : '' }}</span>
                  </div>
                </div>
                <span v-else class="text-gray-400 text-[8px] sm:text-[10px]">Sin transacciones</span>
              </td>
            </tr>
            <tr v-if="serviciosPaginados.length === 0">
              <td colspan="10" class="py-6 text-center text-gray-400 dark:text-gray-500 text-xs sm:text-sm">
                <Icon icon="mdi:inbox-outline" class="text-3xl sm:text-4xl mx-auto mb-2 opacity-50" />
                No hay servicios registrados {{ fechaEtiqueta.toLowerCase() }}
              </td>
            </tr>
          </tbody>
          <tfoot v-if="serviciosFiltrados.length > 0" class="border-t-2 border-gray-200 dark:border-gray-700">
            <tr>
              <td colspan="4" class="pt-3 font-bold text-gray-600 dark:text-gray-400">Totales</td>
              <td class="pt-3 text-right font-black text-gray-800 dark:text-white">
                ${{ serviciosFiltrados.reduce((sum, s) => sum + (s.totalServicio || s.montoCobradoUsd || 0), 0).toFixed(2) }}
              </td>
              <td class="pt-3 text-right font-black text-emerald-600 dark:text-emerald-400">
                ${{ serviciosFiltrados.reduce((sum, s) => sum + (s.montoCobradoUsd || 0), 0).toFixed(2) }}
              </td>
              <td class="pt-3 text-right font-black text-orange-600 dark:text-orange-400">
                ${{ serviciosFiltrados.reduce((sum, s) => sum + (s.financiado || 0), 0).toFixed(2) }}
              </td>
              <td colspan="3" class="pt-3"></td>
            </tr>
          </tfoot>
        </table>
      </div>

      <!-- Paginación -->
      <div v-if="serviciosFiltrados.length > itemsPorPagina" class="mt-4 flex justify-between items-center">
        <button 
          @click="paginaActual = Math.max(1, paginaActual - 1)"
          :disabled="paginaActual === 1"
          class="px-3 py-1 text-sm font-bold rounded-lg bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300 hover:bg-gray-200 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          Anterior
        </button>
        <span class="text-sm text-gray-500 dark:text-gray-400">
          Página {{ paginaActual }} de {{ totalPaginas }}
        </span>
        <button 
          @click="paginaActual = Math.min(totalPaginas, paginaActual + 1)"
          :disabled="paginaActual === totalPaginas"
          class="px-3 py-1 text-sm font-bold rounded-lg bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300 hover:bg-gray-200 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          Siguiente
        </button>
      </div>

      <!-- Resumen rápido -->
      <div v-if="serviciosFiltrados.length > 0" class="mt-4 pt-4 border-t border-gray-100 dark:border-gray-700 flex flex-wrap gap-3 sm:gap-6 justify-end items-center">
        <div class="flex items-center gap-2">
          <span class="text-[8px] sm:text-xs font-bold text-gray-400 uppercase">Taller:</span>
          <span class="text-sm sm:text-base font-bold text-purple-600 dark:text-purple-400">
            ${{ serviciosFiltrados.filter(s => s.tipo !== 'externo').reduce((sum, s) => sum + (s.montoCobradoUsd || 0), 0).toFixed(2) }}
          </span>
        </div>
        <div class="flex items-center gap-2">
          <span class="text-[8px] sm:text-xs font-bold text-gray-400 uppercase">Externos:</span>
          <span class="text-sm sm:text-base font-bold text-cyan-600 dark:text-cyan-400">
            ${{ serviciosFiltrados.filter(s => s.tipo === 'externo').reduce((sum, s) => sum + (s.montoCobradoUsd || 0), 0).toFixed(2) }}
          </span>
        </div>
        <div class="flex items-center gap-2">
          <span class="text-[8px] sm:text-xs font-bold text-gray-400 uppercase">Financiado:</span>
          <span class="text-sm sm:text-base font-bold text-orange-600 dark:text-orange-400">
            ${{ serviciosFiltrados.reduce((sum, s) => sum + (s.financiado || 0), 0).toFixed(2) }}
          </span>
        </div>
      </div>
    </div>

    <!-- ============================================================ -->
    <!-- PANEL DISTRIBUCIÓN VENTAS (POR FECHA) -->
    <!-- ============================================================ -->
    <div v-if="mostrarGraficos" class="bg-white dark:bg-gray-800 rounded-2xl sm:rounded-3xl p-3 sm:p-5 shadow-xl border border-gray-100 dark:border-gray-700 mb-4 sm:mb-6 transition-all duration-300">
      <div class="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3 sm:gap-4 mb-4 sm:mb-6">
        <div>
          <h2 class="text-base sm:text-xl font-bold text-gray-800 dark:text-white flex items-center">
            <Icon icon="mdi:cart-arrow-up" class="mr-2 text-blue-600" />
            Distribución de Ingresos por Ventas ({{ fechaEtiqueta }})
          </h2>
          <p class="text-[10px] sm:text-sm text-gray-500 dark:text-gray-400 mt-0.5" v-if="tasaUbcv">
            Tasa UBCV: <span class="font-bold text-blue-600">Bs. {{ tasaUbcv.toFixed(2) }}</span> por Dólar
          </p>
        </div>
        <div class="text-right bg-blue-50 dark:bg-blue-900/20 border border-blue-100 dark:border-blue-800/30 rounded-xl sm:rounded-2xl px-3 sm:px-5 py-2 sm:py-3 w-full sm:w-auto">
          <p class="text-[8px] sm:text-[10px] text-blue-500 uppercase font-bold tracking-wider">Total Cobrado Ventas</p>
          <p class="text-base sm:text-2xl font-black text-blue-600 dark:text-blue-400">${{ statsHoy.ventas.toFixed(2) }}</p>
          <p class="text-[8px] sm:text-[10px] text-blue-400 font-medium" v-if="tasaUbcv">Bs. {{ (statsHoy.ventas * tasaUbcv).toLocaleString('es-VE', {minimumFractionDigits: 2, maximumFractionDigits: 2}) }}</p>
        </div>
      </div>

      <div class="flex justify-end mb-3 sm:mb-4">
        <div class="flex items-center bg-gray-100 dark:bg-gray-700 p-1 rounded-xl sm:rounded-2xl">
          <button
            @click="monedaActiva = 'USD'"
            :class="['px-3 sm:px-4 py-1.5 sm:py-2 text-[10px] sm:text-xs font-bold rounded-lg sm:rounded-xl transition-all duration-200', monedaActiva === 'USD' ? 'bg-white dark:bg-gray-600 text-blue-600 dark:text-white shadow-md' : 'text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300']"
          >
            Ver en USD ($)
          </button>
          <button
            @click="monedaActiva = 'BS'"
            :class="['px-3 sm:px-4 py-1.5 sm:py-2 text-[10px] sm:text-xs font-bold rounded-lg sm:rounded-xl transition-all duration-200', monedaActiva === 'BS' ? 'bg-white dark:bg-gray-600 text-blue-600 dark:text-white shadow-md' : 'text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300']"
          >
            Ver en Bs (UBCV)
          </button>
        </div>
      </div>

      <div class="w-full overflow-hidden h-[200px] sm:h-[250px] lg:h-[300px] mb-4 sm:mb-6">
        <apexchart
          v-if="cargado"
          height="100%"
          width="100%"
          :options="chartOptionsVentas"
          :series="chartSeriesVentas"
        ></apexchart>
        <div v-else class="flex items-center justify-center h-full">
          <Icon icon="mdi:loading" class="text-4xl animate-spin text-blue-600" />
        </div>
      </div>

      <div class="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-2 sm:gap-4">
        <div
          v-for="(val, label) in metodosVentas"
          :key="label"
          class="p-2 sm:p-4 rounded-xl sm:rounded-2xl border transition-all duration-200"
          :class="[
            val > 0 ? 'bg-gray-50 dark:bg-gray-700/30 border-gray-100 dark:border-gray-700 shadow-sm hover:shadow-md' : 'bg-gray-50/40 dark:bg-gray-800/20 border-gray-100/50 dark:border-gray-800 opacity-40'
          ]"
        >
          <div class="flex items-center gap-2 sm:gap-3">
            <div class="p-1.5 sm:p-2.5 rounded-lg sm:rounded-xl flex-shrink-0" :class="getBadgeStyle(label)">
              <Icon :icon="getIconStyle(label)" class="text-base sm:text-lg" />
            </div>
            <div class="min-w-0">
              <p class="text-[9px] sm:text-[11px] text-gray-500 dark:text-gray-400 font-semibold truncate leading-tight">{{ label }}</p>
              <p class="text-xs sm:text-sm font-black text-gray-800 dark:text-white truncate">
                ${{ val.toFixed(2) }}
              </p>
              <p class="text-[8px] sm:text-[10px] text-gray-400 dark:text-gray-500 font-medium truncate" v-if="tasaUbcv && val > 0">
                Bs. {{ (val * tasaUbcv).toLocaleString('es-VE', {minimumFractionDigits: 2, maximumFractionDigits: 2}) }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div v-if="Object.values(metodosVentas).some(v => v > 0)" class="mt-3 sm:mt-4 pt-3 sm:pt-4 border-t border-gray-100 dark:border-gray-700 flex flex-wrap gap-3 sm:gap-6 justify-end items-center">
        <div class="flex items-center gap-1 sm:gap-2">
          <span class="text-[8px] sm:text-xs font-bold text-gray-400 uppercase">Total USD:</span>
          <span class="text-sm sm:text-base font-black text-blue-600 dark:text-blue-400">
            ${{ Object.values(metodosVentas).reduce((s, v) => s + v, 0).toFixed(2) }}
          </span>
        </div>
        <div v-if="tasaUbcv" class="flex items-center gap-1 sm:gap-2">
          <span class="text-[8px] sm:text-xs font-bold text-gray-400 uppercase">Total Bs.:</span>
          <span class="text-sm sm:text-base font-black text-emerald-600 dark:text-emerald-400">
            {{ (Object.values(metodosVentas).reduce((s, v) => s + v, 0) * tasaUbcv).toLocaleString('es-VE', {minimumFractionDigits: 2, maximumFractionDigits: 2}) }}
          </span>
        </div>
      </div>
    </div>

    <!-- ============================================================ -->
    <!-- PANEL DISTRIBUCIÓN SERVICIOS TALLER (POR FECHA) -->
    <!-- ============================================================ -->
    <div v-if="mostrarGraficos" class="bg-white dark:bg-gray-800 rounded-2xl sm:rounded-3xl p-3 sm:p-5 shadow-xl border border-gray-100 dark:border-gray-700 mb-4 sm:mb-6 transition-all duration-300">
      <div class="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3 sm:gap-4 mb-4 sm:mb-6">
        <div>
          <h2 class="text-base sm:text-xl font-bold text-gray-800 dark:text-white flex items-center">
            <Icon icon="mdi:tools" class="mr-2 text-purple-600" />
            Distribución de Ingresos por Servicios Taller ({{ fechaEtiqueta }})
          </h2>
          <p class="text-[10px] sm:text-sm text-gray-500 dark:text-gray-400 mt-0.5" v-if="tasaUbcv">
            Tasa UBCV: <span class="font-bold text-purple-600">Bs. {{ tasaUbcv.toFixed(2) }}</span> por Dólar
          </p>
        </div>
        <div class="text-right bg-purple-50 dark:bg-purple-900/20 border border-purple-100 dark:border-purple-800/30 rounded-xl sm:rounded-2xl px-3 sm:px-5 py-2 sm:py-3 w-full sm:w-auto">
          <p class="text-[8px] sm:text-[10px] text-purple-500 uppercase font-bold tracking-wider">Total Cobrado Servicios Taller</p>
          <p class="text-base sm:text-2xl font-black text-purple-600 dark:text-purple-400">${{ statsHoy.servicios.toFixed(2) }}</p>
          <p class="text-[8px] sm:text-[10px] text-purple-400 font-medium" v-if="tasaUbcv">Bs. {{ (statsHoy.servicios * tasaUbcv).toLocaleString('es-VE', {minimumFractionDigits: 2, maximumFractionDigits: 2}) }}</p>
        </div>
      </div>

      <div class="flex justify-end mb-3 sm:mb-4">
        <div class="flex items-center bg-gray-100 dark:bg-gray-700 p-1 rounded-xl sm:rounded-2xl">
          <button 
            @click="monedaActiva = 'USD'" 
            :class="['px-3 sm:px-4 py-1.5 sm:py-2 text-[10px] sm:text-xs font-bold rounded-lg sm:rounded-xl transition-all duration-200', monedaActiva === 'USD' ? 'bg-white dark:bg-gray-600 text-purple-600 dark:text-white shadow-md' : 'text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300']"
          >
            Ver en USD ($)
          </button>
          <button 
            @click="monedaActiva = 'BS'" 
            :class="['px-3 sm:px-4 py-1.5 sm:py-2 text-[10px] sm:text-xs font-bold rounded-lg sm:rounded-xl transition-all duration-200', monedaActiva === 'BS' ? 'bg-white dark:bg-gray-600 text-purple-600 dark:text-white shadow-md' : 'text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300']"
          >
            Ver en Bs (UBCV)
          </button>
        </div>
      </div>

      <div class="w-full overflow-hidden h-[200px] sm:h-[250px] lg:h-[300px] mb-4 sm:mb-6">
        <apexchart 
          v-if="cargado"
          height="100%" 
          width="100%" 
          :options="chartOptionsServicios" 
          :series="chartSeriesServicios"
        ></apexchart>
        <div v-else class="flex items-center justify-center h-full">
          <Icon icon="mdi:loading" class="text-4xl animate-spin text-purple-600" />
        </div>
      </div>

      <div class="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-2 sm:gap-4">
        <div
          v-for="(val, label) in metodosServicios"
          :key="label"
          class="p-2 sm:p-4 rounded-xl sm:rounded-2xl border transition-all duration-200"
          :class="[
            val > 0 ? 'bg-gray-50 dark:bg-gray-700/30 border-gray-100 dark:border-gray-700 shadow-sm hover:shadow-md' : 'bg-gray-50/40 dark:bg-gray-800/20 border-gray-100/50 dark:border-gray-800 opacity-40'
          ]"
        >
          <div class="flex items-center gap-2 sm:gap-3">
            <div class="p-1.5 sm:p-2.5 rounded-lg sm:rounded-xl flex-shrink-0" :class="getBadgeStyle(label)">
              <Icon :icon="getIconStyle(label)" class="text-base sm:text-lg" />
            </div>
            <div class="min-w-0">
              <p class="text-[9px] sm:text-[11px] text-gray-500 dark:text-gray-400 font-semibold truncate leading-tight">{{ label }}</p>
              <p class="text-xs sm:text-sm font-black text-gray-800 dark:text-white truncate">
                ${{ val.toFixed(2) }}
              </p>
              <p class="text-[8px] sm:text-[10px] text-gray-400 dark:text-gray-500 font-medium truncate" v-if="tasaUbcv && val > 0">
                Bs. {{ (val * tasaUbcv).toLocaleString('es-VE', {minimumFractionDigits: 2, maximumFractionDigits: 2}) }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div v-if="statsHoy.servicios > 0 || Object.values(metodosServicios).some(v => v > 0)" class="mt-3 sm:mt-4 pt-3 sm:pt-4 border-t border-gray-100 dark:border-gray-700 flex flex-wrap gap-3 sm:gap-6 justify-end items-center">
        <div class="flex items-center gap-1 sm:gap-2">
          <span class="text-[8px] sm:text-xs font-bold text-gray-400 uppercase">Total Cobrado (USD):</span>
          <span class="text-sm sm:text-base font-black text-purple-600 dark:text-purple-400">
            ${{ statsHoy.servicios.toFixed(2) }}
          </span>
        </div>
        <div v-if="tasaUbcv" class="flex items-center gap-1 sm:gap-2">
          <span class="text-[8px] sm:text-xs font-bold text-gray-400 uppercase">Total Cobrado (Bs.):</span>
          <span class="text-sm sm:text-base font-black text-emerald-600 dark:text-emerald-400">
            {{ (statsHoy.servicios * tasaUbcv).toLocaleString('es-VE', {minimumFractionDigits: 2, maximumFractionDigits: 2}) }}
          </span>
        </div>
      </div>
    </div>

    <!-- ============================================================ -->
    <!-- PANEL DISTRIBUCIÓN RECEPCIONES EXPRESS (POR FECHA) -->
    <!-- ============================================================ -->
    <div v-if="mostrarGraficos" class="bg-white dark:bg-gray-800 rounded-2xl sm:rounded-3xl p-3 sm:p-5 shadow-xl border border-gray-100 dark:border-gray-700 mb-4 sm:mb-6 transition-all duration-300">
      <div class="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3 sm:gap-4 mb-4 sm:mb-6">
        <div>
          <h2 class="text-base sm:text-xl font-bold text-gray-800 dark:text-white flex items-center">
            <Icon icon="mdi:flash" class="mr-2 text-yellow-600" />
            Distribución de Ingresos por Recepciones Express ({{ fechaEtiqueta }})
          </h2>
          <p class="text-[10px] sm:text-sm text-gray-500 dark:text-gray-400 mt-0.5" v-if="tasaUbcv">
            Tasa UBCV: <span class="font-bold text-yellow-600">Bs. {{ tasaUbcv.toFixed(2) }}</span> por Dólar
          </p>
        </div>
        <div class="text-right bg-yellow-50 dark:bg-yellow-900/20 border border-yellow-100 dark:border-yellow-800/30 rounded-xl sm:rounded-2xl px-3 sm:px-5 py-2 sm:py-3 w-full sm:w-auto">
          <p class="text-[8px] sm:text-[10px] text-yellow-500 uppercase font-bold tracking-wider">Total Cobrado Express</p>
          <p class="text-base sm:text-2xl font-black text-yellow-600 dark:text-yellow-400">${{ statsHoy.recepcionesExpress.toFixed(2) }}</p>
          <p class="text-[8px] sm:text-[10px] text-yellow-400 font-medium" v-if="tasaUbcv">Bs. {{ (statsHoy.recepcionesExpress * tasaUbcv).toLocaleString('es-VE', {minimumFractionDigits: 2, maximumFractionDigits: 2}) }}</p>
        </div>
      </div>

      <div class="flex justify-end mb-3 sm:mb-4">
        <div class="flex items-center bg-gray-100 dark:bg-gray-700 p-1 rounded-xl sm:rounded-2xl">
          <button 
            @click="monedaActiva = 'USD'" 
            :class="['px-3 sm:px-4 py-1.5 sm:py-2 text-[10px] sm:text-xs font-bold rounded-lg sm:rounded-xl transition-all duration-200', monedaActiva === 'USD' ? 'bg-white dark:bg-gray-600 text-yellow-600 dark:text-white shadow-md' : 'text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300']"
          >
            Ver en USD ($)
          </button>
          <button 
            @click="monedaActiva = 'BS'" 
            :class="['px-3 sm:px-4 py-1.5 sm:py-2 text-[10px] sm:text-xs font-bold rounded-lg sm:rounded-xl transition-all duration-200', monedaActiva === 'BS' ? 'bg-white dark:bg-gray-600 text-yellow-600 dark:text-white shadow-md' : 'text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300']"
          >
            Ver en Bs (UBCV)
          </button>
        </div>
      </div>

      <div class="w-full overflow-hidden h-[200px] sm:h-[250px] lg:h-[300px] mb-4 sm:mb-6">
        <apexchart 
          v-if="cargado"
          height="100%" 
          width="100%" 
          :options="chartOptionsRecepcionesExpress" 
          :series="chartSeriesRecepcionesExpress"
        ></apexchart>
        <div v-else class="flex items-center justify-center h-full">
          <Icon icon="mdi:loading" class="text-4xl animate-spin text-yellow-600" />
        </div>
      </div>

      <div class="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-2 sm:gap-4">
        <div
          v-for="(val, label) in metodosRecepcionesExpress"
          :key="label"
          class="p-2 sm:p-4 rounded-xl sm:rounded-2xl border transition-all duration-200"
          :class="[
            val > 0 ? 'bg-gray-50 dark:bg-gray-700/30 border-gray-100 dark:border-gray-700 shadow-sm hover:shadow-md' : 'bg-gray-50/40 dark:bg-gray-800/20 border-gray-100/50 dark:border-gray-800 opacity-40'
          ]"
        >
          <div class="flex items-center gap-2 sm:gap-3">
            <div class="p-1.5 sm:p-2.5 rounded-lg sm:rounded-xl flex-shrink-0" :class="getBadgeStyle(label)">
              <Icon :icon="getIconStyle(label)" class="text-base sm:text-lg" />
            </div>
            <div class="min-w-0">
              <p class="text-[9px] sm:text-[11px] text-gray-500 dark:text-gray-400 font-semibold truncate leading-tight">{{ label }}</p>
              <p class="text-xs sm:text-sm font-black text-gray-800 dark:text-white truncate">
                ${{ val.toFixed(2) }}
              </p>
              <p class="text-[8px] sm:text-[10px] text-gray-400 dark:text-gray-500 font-medium truncate" v-if="tasaUbcv && val > 0">
                Bs. {{ (val * tasaUbcv).toLocaleString('es-VE', {minimumFractionDigits: 2, maximumFractionDigits: 2}) }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div v-if="Object.values(metodosRecepcionesExpress).some(v => v > 0)" class="mt-3 sm:mt-4 pt-3 sm:pt-4 border-t border-gray-100 dark:border-gray-700 flex flex-wrap gap-3 sm:gap-6 justify-end items-center">
        <div class="flex items-center gap-1 sm:gap-2">
          <span class="text-[8px] sm:text-xs font-bold text-gray-400 uppercase">Total USD:</span>
          <span class="text-sm sm:text-base font-black text-yellow-600 dark:text-yellow-400">
            ${{ Object.values(metodosRecepcionesExpress).reduce((s, v) => s + v, 0).toFixed(2) }}
          </span>
        </div>
        <div v-if="tasaUbcv" class="flex items-center gap-1 sm:gap-2">
          <span class="text-[8px] sm:text-xs font-bold text-gray-400 uppercase">Total Bs.:</span>
          <span class="text-sm sm:text-base font-black text-emerald-600 dark:text-emerald-400">
            {{ (Object.values(metodosRecepcionesExpress).reduce((s, v) => s + v, 0) * tasaUbcv).toLocaleString('es-VE', {minimumFractionDigits: 2, maximumFractionDigits: 2}) }}
          </span>
        </div>
      </div>
    </div>

    <!-- ============================================================ -->
    <!-- PANEL DISTRIBUCIÓN SERVICIOS EXTERNOS (POR FECHA) -->
    <!-- ============================================================ -->
    <div v-if="mostrarGraficos" class="bg-white dark:bg-gray-800 rounded-2xl sm:rounded-3xl p-3 sm:p-5 shadow-xl border border-gray-100 dark:border-gray-700 mb-4 sm:mb-6 transition-all duration-300">
      <div class="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3 sm:gap-4 mb-4 sm:mb-6">
        <div>
          <h2 class="text-base sm:text-xl font-bold text-gray-800 dark:text-white flex items-center">
            <Icon icon="mdi:home-wrench" class="mr-2 text-cyan-600" />
            Distribución de Ingresos por Servicios Externos ({{ fechaEtiqueta }})
          </h2>
          <p class="text-[10px] sm:text-sm text-gray-500 dark:text-gray-400 mt-0.5" v-if="tasaUbcv">
            Tasa UBCV: <span class="font-bold text-cyan-600">Bs. {{ tasaUbcv.toFixed(2) }}</span> por Dólar
          </p>
        </div>
        <div class="text-right bg-cyan-50 dark:bg-cyan-900/20 border border-cyan-100 dark:border-cyan-800/30 rounded-xl sm:rounded-2xl px-3 sm:px-5 py-2 sm:py-3 w-full sm:w-auto">
          <p class="text-[8px] sm:text-[10px] text-cyan-500 uppercase font-bold tracking-wider">Total Cobrado Servicios Externos</p>
          <p class="text-base sm:text-2xl font-black text-cyan-600 dark:text-cyan-400">${{ statsHoy.serviciosExternos.toFixed(2) }}</p>
          <p class="text-[8px] sm:text-[10px] text-cyan-400 font-medium" v-if="tasaUbcv">Bs. {{ (statsHoy.serviciosExternos * tasaUbcv).toLocaleString('es-VE', {minimumFractionDigits: 2, maximumFractionDigits: 2}) }}</p>
        </div>
      </div>

      <div class="flex justify-end mb-3 sm:mb-4">
        <div class="flex items-center bg-gray-100 dark:bg-gray-700 p-1 rounded-xl sm:rounded-2xl">
          <button 
            @click="monedaActiva = 'USD'" 
            :class="['px-3 sm:px-4 py-1.5 sm:py-2 text-[10px] sm:text-xs font-bold rounded-lg sm:rounded-xl transition-all duration-200', monedaActiva === 'USD' ? 'bg-white dark:bg-gray-600 text-cyan-600 dark:text-white shadow-md' : 'text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300']"
          >
            Ver en USD ($)
          </button>
          <button 
            @click="monedaActiva = 'BS'" 
            :class="['px-3 sm:px-4 py-1.5 sm:py-2 text-[10px] sm:text-xs font-bold rounded-lg sm:rounded-xl transition-all duration-200', monedaActiva === 'BS' ? 'bg-white dark:bg-gray-600 text-cyan-600 dark:text-white shadow-md' : 'text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300']"
          >
            Ver en Bs (UBCV)
          </button>
        </div>
      </div>

      <div class="w-full overflow-hidden h-[200px] sm:h-[250px] lg:h-[300px] mb-4 sm:mb-6">
        <apexchart 
          v-if="cargado"
          height="100%" 
          width="100%" 
          :options="chartOptionsServiciosExternos" 
          :series="chartSeriesServiciosExternos"
        ></apexchart>
        <div v-else class="flex items-center justify-center h-full">
          <Icon icon="mdi:loading" class="text-4xl animate-spin text-cyan-600" />
        </div>
      </div>

      <div class="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-2 sm:gap-4">
        <div
          v-for="(val, label) in metodosServiciosExternos"
          :key="label"
          class="p-2 sm:p-4 rounded-xl sm:rounded-2xl border transition-all duration-200"
          :class="[
            val > 0 ? 'bg-gray-50 dark:bg-gray-700/30 border-gray-100 dark:border-gray-700 shadow-sm hover:shadow-md' : 'bg-gray-50/40 dark:bg-gray-800/20 border-gray-100/50 dark:border-gray-800 opacity-40'
          ]"
        >
          <div class="flex items-center gap-2 sm:gap-3">
            <div class="p-1.5 sm:p-2.5 rounded-lg sm:rounded-xl flex-shrink-0" :class="getBadgeStyle(label)">
              <Icon :icon="getIconStyle(label)" class="text-base sm:text-lg" />
            </div>
            <div class="min-w-0">
              <p class="text-[9px] sm:text-[11px] text-gray-500 dark:text-gray-400 font-semibold truncate leading-tight">{{ label }}</p>
              <p class="text-xs sm:text-sm font-black text-gray-800 dark:text-white truncate">
                ${{ val.toFixed(2) }}
              </p>
              <p class="text-[8px] sm:text-[10px] text-gray-400 dark:text-gray-500 font-medium truncate" v-if="tasaUbcv && val > 0">
                Bs. {{ (val * tasaUbcv).toLocaleString('es-VE', {minimumFractionDigits: 2, maximumFractionDigits: 2}) }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div v-if="Object.values(metodosServiciosExternos).some(v => v > 0)" class="mt-3 sm:mt-4 pt-3 sm:pt-4 border-t border-gray-100 dark:border-gray-700 flex flex-wrap gap-3 sm:gap-6 justify-end items-center">
        <div class="flex items-center gap-1 sm:gap-2">
          <span class="text-[8px] sm:text-xs font-bold text-gray-400 uppercase">Total USD:</span>
          <span class="text-sm sm:text-base font-black text-cyan-600 dark:text-cyan-400">
            ${{ Object.values(metodosServiciosExternos).reduce((s, v) => s + v, 0).toFixed(2) }}
          </span>
        </div>
        <div v-if="tasaUbcv" class="flex items-center gap-1 sm:gap-2">
          <span class="text-[8px] sm:text-xs font-bold text-gray-400 uppercase">Total Bs.:</span>
          <span class="text-sm sm:text-base font-black text-emerald-600 dark:text-emerald-400">
            {{ (Object.values(metodosServiciosExternos).reduce((s, v) => s + v, 0) * tasaUbcv).toLocaleString('es-VE', {minimumFractionDigits: 2, maximumFractionDigits: 2}) }}
          </span>
        </div>
      </div>
    </div>

    <!-- ============================================================ -->
    <!-- PANEL DE EQUIPOS POR VENCER (10 a 14 DÍAS) -->
    <!-- ============================================================ -->
    <div v-if="equiposPorVencer.length > 0" class="bg-gradient-to-br from-orange-50 to-amber-50 dark:from-orange-900/20 dark:to-amber-900/20 rounded-2xl sm:rounded-3xl p-3 sm:p-5 shadow-xl border border-orange-200 dark:border-orange-800 mb-4 sm:mb-6">
      <div class="flex items-center gap-2 sm:gap-3 mb-4">
        <div class="p-2 bg-orange-100 dark:bg-orange-900/50 rounded-xl">
          <Icon icon="mdi:clock-alert-outline" class="text-orange-600 dark:text-orange-400 text-xl sm:text-2xl" />
        </div>
        <div>
          <h2 class="text-base sm:text-xl font-black text-orange-900 dark:text-orange-100">Equipos por Vencer (10 - 14 Días)</h2>
          <p class="text-[10px] sm:text-xs text-orange-700 dark:text-orange-300 font-bold">Faltan menos de 5 días para los 15 días (pérdida de responsabilidad).</p>
        </div>
        <span class="ml-auto bg-orange-600 text-white font-black text-[10px] sm:text-xs px-2.5 py-1 rounded-lg shadow-sm">
          {{ equiposPorVencer.length }}
        </span>
      </div>
      
      <div class="overflow-x-auto custom-scrollbar rounded-xl border border-orange-200 dark:border-orange-800/50">
        <table class="w-full text-left border-collapse min-w-[600px] bg-white dark:bg-gray-800">
          <thead>
            <tr class="bg-orange-100/50 dark:bg-orange-900/30">
              <th class="px-3 sm:px-4 py-3 text-[10px] font-black text-orange-800 dark:text-orange-300 uppercase tracking-widest">Orden / Cliente</th>
              <th class="px-3 sm:px-4 py-3 text-[10px] font-black text-orange-800 dark:text-orange-300 uppercase tracking-widest">Equipo</th>
              <th class="px-3 sm:px-4 py-3 text-[10px] font-black text-orange-800 dark:text-orange-300 uppercase tracking-widest">Fecha Reparado</th>
              <th class="px-3 sm:px-4 py-3 text-[10px] font-black text-orange-800 dark:text-orange-300 uppercase tracking-widest text-right">Monto</th>
              <th class="px-3 sm:px-4 py-3 text-[10px] font-black text-orange-800 dark:text-orange-300 uppercase tracking-widest text-center">Acción</th>
            </tr>
          </thead>
          <tbody class="divide-y divide-orange-100 dark:divide-orange-800/50">
            <tr v-for="item in paginatedEquiposPorVencer" :key="item.idRecepcionEquipo" class="hover:bg-orange-50/50 dark:hover:bg-orange-900/20 transition-colors">
              <td class="px-3 sm:px-4 py-3">
                <p class="font-black text-gray-900 dark:text-white text-xs">#{{ item.numeroOrden }}</p>
                <p class="text-[10px] font-medium text-gray-500 dark:text-gray-400">{{ item.nombreCliente }}</p>
              </td>
              <td class="px-3 sm:px-4 py-3">
                <p class="font-bold text-gray-800 dark:text-gray-200 text-[11px]">{{ item.descripcion }}</p>
              </td>
              <td class="px-3 sm:px-4 py-3">
                <p class="font-black text-orange-600 dark:text-orange-400 text-[11px]">
                  {{ new Date(item.fechaReparacion).toLocaleDateString('es-VE') }}
                </p>
                <p class="text-[9px] font-bold text-orange-500/70 dark:text-orange-400/70">
                  Hace {{ Math.floor((new Date() - new Date(item.fechaReparacion)) / (1000 * 60 * 60 * 24)) }} días
                </p>
              </td>
              <td class="px-3 sm:px-4 py-3 text-right">
                <p class="font-black text-gray-900 dark:text-white text-[11px]">
                  ${{ (item.precioTotalUsd || 0).toFixed(2) }}
                </p>
                <p v-if="item.montoPagadoReparacionUsd > 0" class="text-[9px] font-bold text-green-600 dark:text-green-400">
                  Abono: ${{ item.montoPagadoReparacionUsd.toFixed(2) }}
                </p>
              </td>
              <td class="px-3 sm:px-4 py-3 text-center">
                <button 
                  @click="notificarWhatsappRetraso(item, 'porVencer')"
                  class="p-2 bg-orange-500 hover:bg-orange-600 text-white rounded-xl shadow-md shadow-orange-500/30 transition-all flex items-center justify-center gap-1.5 mx-auto"
                  title="Enviar Recordatorio por WhatsApp"
                >
                  <Icon icon="mdi:whatsapp" class="text-sm" />
                  <span class="text-[10px] font-black tracking-widest hidden sm:inline">AVISAR</span>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- Paginación Por Vencer -->
      <div v-if="equiposPorVencer.length > itemsPorPaginaPorVencer" class="mt-3 flex items-center justify-between">
        <button @click="paginaPorVencer--" :disabled="paginaPorVencer === 1" class="px-3 py-1 bg-white dark:bg-gray-700 text-gray-700 dark:text-white rounded-lg shadow disabled:opacity-50 text-xs font-bold transition-all">Anterior</button>
        <span class="text-xs font-bold text-orange-800 dark:text-orange-200">Página {{ paginaPorVencer }} de {{ Math.ceil(equiposPorVencer.length / itemsPorPaginaPorVencer) }}</span>
        <button @click="paginaPorVencer++" :disabled="paginaPorVencer >= Math.ceil(equiposPorVencer.length / itemsPorPaginaPorVencer)" class="px-3 py-1 bg-white dark:bg-gray-700 text-gray-700 dark:text-white rounded-lg shadow disabled:opacity-50 text-xs font-bold transition-all">Siguiente</button>
      </div>
    </div>

    <!-- ============================================================ -->
    <!-- PANEL DE EQUIPOS RETRASADOS (15+ DÍAS) -->
    <!-- ============================================================ -->
    <div v-if="equiposRetrasados.length > 0" class="bg-gradient-to-br from-rose-50 to-red-50 dark:from-rose-900/20 dark:to-red-900/20 rounded-2xl sm:rounded-3xl p-3 sm:p-5 shadow-xl border border-rose-200 dark:border-rose-800 mb-4 sm:mb-6">
      <div class="flex items-center gap-2 sm:gap-3 mb-4">
        <div class="p-2 bg-rose-100 dark:bg-rose-900/50 rounded-xl">
          <Icon icon="mdi:alert-circle-outline" class="text-rose-600 dark:text-rose-400 text-xl sm:text-2xl" />
        </div>
        <div>
          <h2 class="text-base sm:text-xl font-black text-rose-900 dark:text-rose-100">Equipos Listos (Más de 15 Días)</h2>
          <p class="text-[10px] sm:text-xs text-rose-700 dark:text-rose-300 font-bold">Estos equipos están listos pero no han sido retirados. Sugerimos cobrar almacenaje o notificar.</p>
        </div>
        <span class="ml-auto bg-rose-600 text-white font-black text-[10px] sm:text-xs px-2.5 py-1 rounded-lg shadow-sm">
          {{ equiposRetrasados.length }}
        </span>
      </div>
      
      <div class="overflow-x-auto custom-scrollbar rounded-xl border border-rose-200 dark:border-rose-800/50">
        <table class="w-full text-left border-collapse min-w-[600px] bg-white dark:bg-gray-800">
          <thead>
            <tr class="bg-rose-100/50 dark:bg-rose-900/30">
              <th class="px-3 sm:px-4 py-3 text-[10px] font-black text-rose-800 dark:text-rose-300 uppercase tracking-widest">Orden / Cliente</th>
              <th class="px-3 sm:px-4 py-3 text-[10px] font-black text-rose-800 dark:text-rose-300 uppercase tracking-widest">Equipo</th>
              <th class="px-3 sm:px-4 py-3 text-[10px] font-black text-rose-800 dark:text-rose-300 uppercase tracking-widest">Fecha Reparado</th>
              <th class="px-3 sm:px-4 py-3 text-[10px] font-black text-rose-800 dark:text-rose-300 uppercase tracking-widest text-right">Monto</th>
              <th class="px-3 sm:px-4 py-3 text-[10px] font-black text-rose-800 dark:text-rose-300 uppercase tracking-widest text-center">Acción</th>
            </tr>
          </thead>
          <tbody class="divide-y divide-rose-100 dark:divide-rose-800/50">
            <tr v-for="item in paginatedEquiposRetrasados" :key="item.idRecepcionEquipo" class="hover:bg-rose-50/50 dark:hover:bg-rose-900/20 transition-colors">
              <td class="px-3 sm:px-4 py-3">
                <p class="font-black text-gray-900 dark:text-white text-xs">#{{ item.numeroOrden }}</p>
                <p class="text-[10px] font-medium text-gray-500 dark:text-gray-400">{{ item.nombreCliente }}</p>
              </td>
              <td class="px-3 sm:px-4 py-3">
                <p class="font-bold text-gray-800 dark:text-gray-200 text-[11px]">{{ item.descripcion }}</p>
              </td>
              <td class="px-3 sm:px-4 py-3">
                <p class="font-black text-rose-600 dark:text-rose-400 text-[11px]">
                  {{ new Date(item.fechaReparacion).toLocaleDateString('es-VE') }}
                </p>
                <p class="text-[9px] font-bold text-rose-500/70 dark:text-rose-400/70">
                  Hace {{ Math.floor((new Date() - new Date(item.fechaReparacion)) / (1000 * 60 * 60 * 24)) }} días
                </p>
              </td>
              <td class="px-3 sm:px-4 py-3 text-right">
                <p class="font-black text-gray-900 dark:text-white text-[11px]">
                  ${{ (item.precioTotalUsd || 0).toFixed(2) }}
                </p>
                <p v-if="item.montoPagadoReparacionUsd > 0" class="text-[9px] font-bold text-green-600 dark:text-green-400">
                  Abono: ${{ item.montoPagadoReparacionUsd.toFixed(2) }}
                </p>
              </td>
              <td class="px-3 sm:px-4 py-3 text-center">
                <button 
                  @click="notificarWhatsappRetraso(item, 'retrasado')"
                  class="p-2 bg-green-500 hover:bg-green-600 text-white rounded-xl shadow-md shadow-green-500/30 transition-all flex items-center justify-center gap-1.5 mx-auto"
                  title="Enviar Recordatorio por WhatsApp"
                >
                  <Icon icon="mdi:whatsapp" class="text-sm" />
                  <span class="text-[10px] font-black tracking-widest hidden sm:inline">NOTIFICAR</span>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- Paginación Retrasados -->
      <div v-if="equiposRetrasados.length > itemsPorPaginaRetrasados" class="mt-3 flex items-center justify-between">
        <button @click="paginaRetrasados--" :disabled="paginaRetrasados === 1" class="px-3 py-1 bg-white dark:bg-gray-700 text-gray-700 dark:text-white rounded-lg shadow disabled:opacity-50 text-xs font-bold transition-all">Anterior</button>
        <span class="text-xs font-bold text-rose-800 dark:text-rose-200">Página {{ paginaRetrasados }} de {{ Math.ceil(equiposRetrasados.length / itemsPorPaginaRetrasados) }}</span>
        <button @click="paginaRetrasados++" :disabled="paginaRetrasados >= Math.ceil(equiposRetrasados.length / itemsPorPaginaRetrasados)" class="px-3 py-1 bg-white dark:bg-gray-700 text-gray-700 dark:text-white rounded-lg shadow disabled:opacity-50 text-xs font-bold transition-all">Siguiente</button>
      </div>
    </div>

    <!-- ============================================================ -->
    <!-- BOTÓN DE IMPRESIÓN RÁPIDA -->
    <!-- ============================================================ -->
    <div class="mb-4 sm:mb-6">
      <button 
        @click="imprimirGeneral"
        class="w-full py-4 sm:py-6 bg-gradient-to-r from-blue-700 via-indigo-700 to-purple-800 text-white rounded-2xl sm:rounded-3xl shadow-2xl hover:shadow-indigo-500/50 transition-all duration-300 flex items-center justify-center gap-3 sm:gap-4 group overflow-hidden relative"
      >
        <div class="absolute inset-0 bg-white/10 translate-y-full group-hover:translate-y-0 transition-transform duration-500"></div>
        <div class="p-2 sm:p-3 bg-white/20 rounded-xl sm:rounded-2xl group-hover:scale-110 transition-transform">
          <Icon icon="mdi:printer-check" class="text-2xl sm:text-3xl" />
        </div>
        <div class="text-left">
          <p class="text-[8px] sm:text-[10px] uppercase font-black tracking-widest opacity-80">Acceso Rápido</p>
          <h2 class="text-base sm:text-2xl font-black">Imprimir Reporte General del {{ fechaEtiqueta }}</h2>
        </div>
        <Icon icon="mdi:arrow-right" class="text-xl sm:text-2xl group-hover:translate-x-2 transition-transform" />
      </button>
    </div>

    <!-- ============================================================ -->
    <!-- MENÚ DE REPORTES DETALLADOS -->
    <!-- ============================================================ -->
    <h2 class="text-base sm:text-xl font-bold text-gray-800 dark:text-white mb-3 sm:mb-6 flex items-center">
      <Icon icon="mdi:view-grid-outline" class="mr-2 text-blue-600" />
      Reportes Individuales
    </h2>

    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-3 sm:gap-4">
      <!-- Reporte de Ventas -->
      <button @click="$router.push('/reporte-ventas')" class="flex items-center p-3 sm:p-5 bg-white dark:bg-gray-800 rounded-2xl sm:rounded-3xl shadow-lg border border-gray-100 dark:border-gray-700 hover:border-blue-500 dark:hover:border-blue-500 transition-all group text-left transform hover:-translate-y-1 hover:shadow-2xl">
        <div class="p-2 sm:p-4 bg-blue-100 dark:bg-blue-900/30 rounded-xl sm:rounded-2xl text-blue-600 dark:text-blue-400 mr-3 sm:mr-4 group-hover:scale-110 transition-transform">
          <Icon icon="mdi:cart-arrow-up" class="text-2xl sm:text-3xl" />
        </div>
        <div>
          <h4 class="font-bold text-gray-900 dark:text-white text-sm sm:text-base">Ventas</h4>
          <p class="text-[10px] sm:text-xs text-gray-500 dark:text-gray-400">Productos vendidos</p>
        </div>
      </button>

      <!-- Reporte de Servicios Taller -->
      <button @click="$router.push('/pago-servicio')" class="flex items-center p-3 sm:p-5 bg-white dark:bg-gray-800 rounded-2xl sm:rounded-3xl shadow-lg border border-gray-100 dark:border-gray-700 hover:border-purple-500 dark:hover:border-purple-500 transition-all group text-left transform hover:-translate-y-1 hover:shadow-2xl">
        <div class="p-2 sm:p-4 bg-purple-100 dark:bg-purple-900/30 rounded-xl sm:rounded-2xl text-purple-600 dark:text-purple-400 mr-3 sm:mr-4 group-hover:scale-110 transition-transform">
          <Icon icon="mdi:tools" class="text-2xl sm:text-3xl" />
        </div>
        <div>
          <h4 class="font-bold text-gray-900 dark:text-white text-sm sm:text-base">Servicios Taller</h4>
          <p class="text-[10px] sm:text-xs text-gray-500 dark:text-gray-400">Reparaciones en taller</p>
        </div>
      </button>

      <!-- Reporte de Recepciones Express -->
      <button @click="$router.push('/pago-servicio')" class="flex items-center p-3 sm:p-5 bg-white dark:bg-gray-800 rounded-2xl sm:rounded-3xl shadow-lg border border-gray-100 dark:border-gray-700 hover:border-yellow-500 dark:hover:border-yellow-500 transition-all group text-left transform hover:-translate-y-1 hover:shadow-2xl">
        <div class="p-2 sm:p-4 bg-yellow-100 dark:bg-yellow-900/30 rounded-xl sm:rounded-2xl text-yellow-600 dark:text-yellow-400 mr-3 sm:mr-4 group-hover:scale-110 transition-transform">
          <Icon icon="mdi:flash" class="text-2xl sm:text-3xl" />
        </div>
        <div>
          <h4 class="font-bold text-gray-900 dark:text-white text-sm sm:text-base">Recepciones Express</h4>
          <p class="text-[10px] sm:text-xs text-gray-500 dark:text-gray-400">Diagnósticos exprés</p>
        </div>
      </button>

      <!-- Reporte de Servicios Externos -->
      <button @click="$router.push('/servicios-externos')" class="flex items-center p-3 sm:p-5 bg-white dark:bg-gray-800 rounded-2xl sm:rounded-3xl shadow-lg border border-gray-100 dark:border-gray-700 hover:border-cyan-500 dark:hover:border-cyan-500 transition-all group text-left transform hover:-translate-y-1 hover:shadow-2xl">
        <div class="p-2 sm:p-4 bg-cyan-100 dark:bg-cyan-900/30 rounded-xl sm:rounded-2xl text-cyan-600 dark:text-cyan-400 mr-3 sm:mr-4 group-hover:scale-110 transition-transform">
          <Icon icon="mdi:home-wrench" class="text-2xl sm:text-3xl" />
        </div>
        <div>
          <h4 class="font-bold text-gray-900 dark:text-white text-sm sm:text-base">Servicios Externos</h4>
          <p class="text-[10px] sm:text-xs text-gray-500 dark:text-gray-400">A domicilio</p>
        </div>
      </button>

      <!-- Reporte Consolidado -->
      <button @click="imprimirGeneral" class="flex items-center p-3 sm:p-5 bg-white dark:bg-gray-800 rounded-2xl sm:rounded-3xl shadow-lg border border-gray-100 dark:border-gray-700 hover:border-emerald-500 dark:hover:border-emerald-500 transition-all group text-left transform hover:-translate-y-1 hover:shadow-2xl">
        <div class="p-2 sm:p-4 bg-emerald-100 dark:bg-emerald-900/30 rounded-xl sm:rounded-2xl text-emerald-600 dark:text-emerald-400 mr-3 sm:mr-4 group-hover:scale-110 transition-transform">
          <Icon icon="mdi:printer-check" class="text-2xl sm:text-3xl" />
        </div>
        <div>
          <h4 class="font-bold text-gray-900 dark:text-white text-sm sm:text-base">Consolidado</h4>
          <p class="text-[10px] sm:text-xs text-gray-500 dark:text-gray-400">Todos los reportes</p>
        </div>
      </button>
    </div>
  </div>
    <!-- Modal Cashea Semanal -->
    <div v-if="mostrarModalCasheaSemanal" class="fixed inset-0 z-[100] flex items-center justify-center bg-gray-900/60 backdrop-blur-sm px-4">
      <div class="bg-white dark:bg-gray-800 rounded-3xl p-6 sm:p-8 max-w-md w-full shadow-2xl animate-fadeInUp relative border border-gray-100 dark:border-gray-700">
        <button @click="cerrarModalCashea" class="absolute top-4 right-4 text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 transition-colors">
          <Icon icon="mdi:close" class="text-2xl" />
        </button>
        <div class="flex items-center justify-center w-16 h-16 mx-auto bg-violet-100 dark:bg-violet-900/40 text-violet-600 dark:text-violet-400 rounded-full mb-4">
          <Icon icon="mdi:lightning-bolt" class="text-3xl" />
        </div>
        <h3 class="text-xl font-black text-center text-gray-900 dark:text-white mb-2">Recordatorio Semanal Cashea</h3>
        <p class="text-sm text-center text-gray-500 dark:text-gray-400 mb-6">Debes retirar el monto total generado en Cashea durante la última semana.</p>
        
        <div class="bg-gray-50 dark:bg-gray-900/50 rounded-2xl p-4 mb-6 border border-gray-100 dark:border-gray-700">
          <p class="text-[10px] font-bold text-gray-400 uppercase tracking-wider text-center mb-1">Período de Facturación</p>
          <p class="text-sm font-semibold text-gray-700 dark:text-gray-300 text-center mb-4">{{ fechasCasheaSemanal }}</p>
          
          <p class="text-[10px] font-bold text-violet-500 uppercase tracking-wider text-center mb-1">Total a Retirar</p>
          <p class="text-4xl font-black text-center text-violet-600 dark:text-violet-400">${{ montoCasheaSemanal.toFixed(2) }}</p>
        </div>

        <button @click="cerrarModalCashea" class="w-full py-3.5 bg-violet-600 hover:bg-violet-700 text-white rounded-xl font-bold transition-all shadow-lg shadow-violet-500/30">
          Entendido
        </button>
      </div>
    </div>
</template>

<script>
import { Icon } from "@iconify/vue";
import { obtenerVentas } from '@/api/ventas.js';
import { obtenerPagosPorVenta } from '@/api/pagoVenta.js';
import { obtenerClientes } from '@/api/clientes.js';
import { imprimirReporteConsolidado } from '@/utils/reporteConsolidadoGenerator.js';
import { obtenerTasaVentaActual } from '@/api/tasaVenta.js';
import apiServiciosExternos from '@/api/serviciosExternos.js';
import { obtenerPagosSalidaEquipo } from '@/api/pagoSalidaEquipo.js';
import apiRecepcion from '@/api/recepcionEquipo.js';
import { obtenerFinanciadoEquiposMinimo } from '@/api/creditoSalidaEquipo.js';

export default {
  name: 'ReporteGestion',
  components: { Icon },
  data() {
    return {
      fechaInput: new Date().toLocaleDateString('sv-SE'),
      fechaMaxima: new Date().toLocaleDateString('sv-SE'),
      
      cargandoStats: false,
      cargado: false,
      mostrarGraficos: false,
      filtroEstadoServicios: 'todos',
      paginaActual: 1,
      itemsPorPagina: 20,
      statsHoy: {
        ventas: 0,
        servicios: 0,
        recepcionesExpress: 0,
        serviciosExternos: 0,
        conteo: 0
      },
      ventasOriginales: [],
      serviciosOriginales: [],
      serviciosExternosOriginales: [],
      
      // Modal Recordatorio Cashea Semanal
      mostrarModalCasheaSemanal: false,
      montoCasheaSemanal: 0,
      fechasCasheaSemanal: '',
      esMiercoles: false,
      pagosServicios: [],
      cuotasServiciosMap: new Map(),
      clientesMap: new Map(),
      tasaUbcv: null,
      monedaActiva: 'USD',
      fechaActual: new Date().toLocaleDateString('es-VE', { day: '2-digit', month: 'short', year: 'numeric' }),
      metodosServicios: {
        'Efectivo Bs': 0,
        'Efectivo USD': 0,
        'Pago Móvil': 0,
        'Punto de Venta': 0,
        'Transferencia Bs': 0,
        'Transferencia USD': 0,
        'Crédito Cashea': 0,
        'Crédito Empresarial': 0
      },
      metodosRecepcionesExpress: {
        'Efectivo Bs': 0,
        'Efectivo USD': 0,
        'Pago Móvil': 0,
        'Punto de Venta': 0,
        'Transferencia Bs': 0,
        'Transferencia USD': 0,
        'Crédito Cashea': 0,
        'Crédito Empresarial': 0
      },
      metodosServiciosExternos: {
        'Efectivo Bs': 0,
        'Efectivo USD': 0,
        'Pago Móvil': 0,
        'Punto de Venta': 0,
        'Transferencia Bs': 0,
        'Transferencia USD': 0,
        'Crédito Cashea': 0,
        'Crédito Empresarial': 0
      },
      metodosVentas: {
        'Efectivo Bs': 0,
        'Efectivo USD': 0,
        'Pago Móvil': 0,
        'Punto de Venta': 0,
        'Transferencia Bs': 0,
        'Transferencia USD': 0,
        'Crédito Cashea': 0,
        'Crédito Empresarial': 0
      },
      cacheTimestamp: null,
      CACHE_TTL: 300000,
      equiposRetrasados: [],
      equiposPorVencer: [],
      paginaRetrasados: 1,
      itemsPorPaginaRetrasados: 5,
      paginaPorVencer: 1,
      itemsPorPaginaPorVencer: 5,
      clientesPhoneMap: new Map()
    };
  },
  computed: {
    paginatedEquiposRetrasados() {
      const start = (this.paginaRetrasados - 1) * this.itemsPorPaginaRetrasados;
      return this.equiposRetrasados.slice(start, start + this.itemsPorPaginaRetrasados);
    },
    paginatedEquiposPorVencer() {
      const start = (this.paginaPorVencer - 1) * this.itemsPorPaginaPorVencer;
      return this.equiposPorVencer.slice(start, start + this.itemsPorPaginaPorVencer);
    },
    fechaSeleccionadaFormateada() {
      if (!this.fechaInput) return 'Seleccionar fecha';
      const partes = this.fechaInput.split('-');
      const d = new Date(partes[0], partes[1] - 1, partes[2]);
      return d.toLocaleDateString('es-VE', { 
        day: '2-digit', 
        month: 'short', 
        year: 'numeric' 
      });
    },

    fechaEtiqueta() {
      if (!this.fechaInput) return 'HOY';
      const partes = this.fechaInput.split('-');
      const d = new Date(partes[0], partes[1] - 1, partes[2]);
      const hoy = new Date();
      if (d.toDateString() === hoy.toDateString()) {
        return 'HOY';
      }
      return d.toLocaleDateString('es-VE', { day: '2-digit', month: 'short' }).toUpperCase();
    },

    fechaStr() {
      if (!this.fechaInput) return new Date().toLocaleDateString('sv-SE');
      return this.fechaInput;
    },

    metodosReales() {
      return ['Efectivo Bs', 'Efectivo USD', 'Pago Móvil', 'Punto de Venta', 'Transferencia Bs', 'Transferencia USD'];
    },

    totalDiario() {
      let total = 0;
      for (const key of this.metodosReales) {
        total += this.metodosVentas[key] || 0;
        total += this.metodosServicios[key] || 0;
        total += this.metodosRecepcionesExpress[key] || 0;
        total += this.metodosServiciosExternos[key] || 0;
      }
      return total;
    },

    totalCreditosServiciosExternos() {
      return (this.metodosServiciosExternos['Crédito Cashea'] || 0) + 
             (this.metodosServiciosExternos['Crédito Empresarial'] || 0);
    },

    totalCreditosCasheaExternos() {
      return this.metodosServiciosExternos['Crédito Cashea'] || 0;
    },

    totalCreditosEmpresarialExternos() {
      return this.metodosServiciosExternos['Crédito Empresarial'] || 0;
    },
    
    serviciosDiarios() {
      const fechaStr = this.fechaStr;
      const resultado = [];
      
      const normalizarFecha = (fechaStr) => {
        if (!fechaStr) return null;
        if (fechaStr.match(/^\d{4}-\d{2}-\d{2}/)) {
          return fechaStr.substring(0, 10);
        }
        const meses = {
          'ene': '01', 'feb': '02', 'mar': '03', 'abr': '04', 'may': '05', 'jun': '06',
          'jul': '07', 'ago': '08', 'sep': '09', 'oct': '10', 'nov': '11', 'dic': '12'
        };
        const match = fechaStr.match(/(\d{1,2})\s*([a-z]{3})\s*(\d{4})/i);
        if (match) {
          const dia = match[1].padStart(2, '0');
          const mes = meses[match[2].toLowerCase()] || '01';
          const año = match[3];
          return `${año}-${mes}-${dia}`;
        }
        const d = new Date(fechaStr);
        if (!isNaN(d.getTime())) {
          return d.toISOString().substring(0, 10);
        }
        return null;
      };
      
      // --- 1. PROCESAR SERVICIOS INTERNOS (TALLER) ---
      if (this.serviciosOriginales && this.serviciosOriginales.length > 0) {
        const pagosMap = new Map();
        for (const p of this.pagosServicios) {
          const key = p.idRecepcionEquipo || p.id_recepcion_equipo || p.idRecepcion;
          if (key) {
            if (!pagosMap.has(key)) pagosMap.set(key, []);
            pagosMap.get(key).push(p);
          }
        }

        for (const s of this.serviciosOriginales) {
          const fechaIngreso = s.fechaIngreso || s.FechaIngreso || '';
          const fechaPago = s.fechaPago || s.FechaPago || '';
          const fechaEntrega = s.fechaEntrega || s.FechaEntrega || '';
          const fechaRef = s.fechaReferencia || '';
          
          const fechasNormalizadas = [
            normalizarFecha(fechaIngreso),
            normalizarFecha(fechaPago),
            normalizarFecha(fechaEntrega),
            normalizarFecha(fechaRef)
          ];
          
          // Verificar si el servicio coincide por sus fechas propias
          let coincideFecha = fechasNormalizadas.some(f => f === fechaStr);
          
          // Obtener pagos y cuotas del servicio
          const key = s.idRecepcionEquipo ?? s.id_recepcion_equipo ?? s.idRecepcion ?? s.id;
          const pagos = key ? pagosMap.get(key) || [] : [];
          
          // 👈 Verificar si tiene pagos (pagosServicios) de HOY
          const pagosHoy = pagos.filter(p => {
            const fPago = p.fechaPago || p.fecha_pago || '';
            return normalizarFecha(fPago) === fechaStr;
          });
          
          // 👈 Verificar si tiene cuotas de crédito con fechaPago HOY
          const creditos = s.creditos || s.cuotas || s.creditosSalidaEquipo || s.cuotasCredito || [];
          const cuotasPagadasHoy = creditos.filter(c => {
            const fPagoCuota = c.fechaPago || c.fecha_pago || '';
            return normalizarFecha(fPagoCuota) === fechaStr;
          });
          
          // Si NO coincide por fecha propia Y NO tiene pagos hoy Y NO tiene cuotas hoy → saltar
          if (!coincideFecha && pagosHoy.length === 0 && cuotasPagadasHoy.length === 0) {
            continue;
          }

          const totalServicio = parseFloat(s.precioTotalUsd || s.montoCobradoUsd || 0);
          
          const met = (s.metodoPago || '').toUpperCase();
          const esCashea = met.includes('CACHEA');
          const esEmpresarial = met.includes('EMPRESA') || met.includes('EMPRESARIAL') || met.includes('CORPORATIVO');
          const esCredito = esCashea || esEmpresarial;
          
          // 👈 Cobrado = pagos normales hoy + cuotas de crédito pagadas hoy
          let cobrado = pagosHoy.reduce((sum, p) => sum + (parseFloat(p.montoUsd || p.monto_usd) || 0), 0);
          cobrado += cuotasPagadasHoy.reduce((sum, c) => {
            return sum + (parseFloat(c.montoUsd || c.monto_usd || c.montoPagoUsd || c.monto_pago_usd || 0) || 0);
          }, 0);
          
          let financiado = 0;
          if (esCredito) {
            financiado = Math.max(0, totalServicio - cobrado);
          }

          const estado = (s.nombreEstado || s.estado || '').toLowerCase();
          const estadoCompletado = estado.includes('entregado') || 
                                  estado.includes('completado') || 
                                  estado.includes('finalizado') ||
                                  estado.includes('cerrado');

          // 👈 Construir transacciones (pagos + cuotas)
          const transacciones = [];
          
          pagosHoy.forEach(p => {
            transacciones.push({
              metodo: p.metodoPago || p.tipoPago || 'Efectivo',
              monto: parseFloat(p.montoUsd || p.monto_usd) || 0,
              fecha: p.fechaPago || p.fecha_pago || ''
            });
          });
          
          cuotasPagadasHoy.forEach(c => {
            transacciones.push({
              metodo: c.metodoPago || c.tipoPago || 'Abono Crédito',
              monto: parseFloat(c.montoUsd || c.monto_usd || c.montoPagoUsd || c.monto_pago_usd || 0) || 0,
              fecha: c.fechaPago || c.fecha_pago || ''
            });
          });

          resultado.push({
            id: s.idRecepcionEquipo || s.id,
            numeroOrden: s.numeroOrden || s.idRecepcionEquipo || 'N/A',
            tipo: 'interno',
            clienteNombre: this.clientesMap.get(s.idCliente) || s.clienteNombre || s.cliente || 'Cliente',
            metodoPago: s.metodoPago || 'Efectivo',
            totalServicio: totalServicio,
            montoCobradoUsd: cobrado,
            financiado: financiado,
            estado: s.nombreEstado || s.estado || 'Pendiente',
            estadoCompletado: estadoCompletado,
            fechaIngreso: fechaIngreso,
            transacciones: transacciones,
            _original: s,
            _pagos: pagos,
            _cuotasPagadasHoy: cuotasPagadasHoy
          });
        }
      }

      // --- 2. PROCESAR SERVICIOS EXTERNOS ---
      if (this.serviciosExternosOriginales && this.serviciosExternosOriginales.length > 0) {
        for (const s of this.serviciosExternosOriginales) {
          const fechaPago = s.fechaPago || s.fecha_pago || s.fecha || '';
          const fechaCompletado = s.fechaFinalizacion || s.fecha_finalizacion || s.fechaCompletado || '';
          const fechaCreacion = s.fechaCreacion || s.fecha_creacion || s.createdAt || '';
          
          const fechasNormalizadas = [
            normalizarFecha(fechaPago),
            normalizarFecha(fechaCompletado),
            normalizarFecha(fechaCreacion)
          ];
          
          let coincideFecha = fechasNormalizadas.some(f => f === fechaStr);
          
          // 👈 Verificar cuotas del crédito del servicio externo
          const cuotasCredito = s.cuotasCredito || s.creditos || s.cuotas || [];
          const cuotasPagadasHoy = cuotasCredito.filter(c => {
            const fPagoCuota = c.fechaPago || c.fecha_pago || '';
            return normalizarFecha(fPagoCuota) === fechaStr;
          });
          
          if (!coincideFecha && cuotasPagadasHoy.length === 0) {
            const stringData = JSON.stringify(s);
            if (stringData.includes(fechaStr)) {
              coincideFecha = true;
            }
          }
          
          if (!coincideFecha && cuotasPagadasHoy.length === 0) continue;

          const monto = parseFloat(s.montoPagado || s.monto_pagado || s.costo || s.monto || 0);
          const metodo = (s.metodoPago || s.metodo_pago || s.metodo || 'EFECTIVO').toString().toUpperCase();
          const esCredito = metodo.includes('EMPRESA') || 
                           metodo.includes('EMPRESARIAL') || 
                           metodo.includes('CORPORATIVO') ||
                           metodo.includes('CREDITO') ||
                           metodo.includes('CACHEA') ||
                           metodo.includes('CRÉDITO');
          
          let financiado = 0;
          let cobradoHoy = monto;
          
          // 👈 Si hay cuotas pagadas hoy, sumar esos montos
          if (cuotasPagadasHoy.length > 0) {
            cobradoHoy = cuotasPagadasHoy.reduce((sum, c) => {
              return sum + (parseFloat(c.montoUsd || c.monto_usd || c.montoPagoUsd || c.monto_pago_usd || 0) || 0);
            }, 0);
          }
          
          if (esCredito) {
            financiado = Math.max(0, monto - cobradoHoy);
          }

          const estado = s.estado || s.nombreEstado || s.estatus || 'Completado';
          const estadoCompletado = estado.toLowerCase().includes('completado') || 
                                  estado.toLowerCase().includes('finalizado') ||
                                  estado.toLowerCase().includes('entregado') ||
                                  estado.toLowerCase().includes('pagado');

          const transacciones = [];
          
          if (cuotasPagadasHoy.length > 0) {
            cuotasPagadasHoy.forEach(c => {
              transacciones.push({
                metodo: c.metodoPago || c.tipoPago || 'Abono Crédito',
                monto: parseFloat(c.montoUsd || c.monto_usd || c.montoPagoUsd || c.monto_pago_usd || 0) || 0,
                fecha: c.fechaPago || c.fecha_pago || ''
              });
            });
          } else if (cobradoHoy > 0) {
            transacciones.push({
              metodo: s.metodoPago || s.metodo_pago || 'Efectivo',
              monto: cobradoHoy,
              fecha: fechaPago || fechaCompletado || fechaCreacion || ''
            });
          }

          resultado.push({
            id: s.idServicioExterno || s.id || s.id_servicio_externo || 'N/A',
            numeroOrden: s.idServicioExterno || s.id || s.numeroOrden || 'N/A',
            tipo: 'externo',
            clienteNombre: s.cliente || s.clienteNombre || s.cliente_nombre || s.nombreCliente || 'Cliente',
            metodoPago: s.metodoPago || s.metodo_pago || 'Efectivo',
            totalServicio: monto,
            montoCobradoUsd: cobradoHoy,
            financiado: financiado,
            estado: estado,
            estadoCompletado: estadoCompletado,
            fechaIngreso: fechaPago || fechaCompletado || fechaCreacion || '',
            transacciones: transacciones,
            _original: s
          });
        }
      }

      resultado.sort((a, b) => {
        if (a.fechaIngreso && b.fechaIngreso) {
          return new Date(b.fechaIngreso) - new Date(a.fechaIngreso);
        }
        return 0;
      });

      return resultado;
    },

    serviciosExternosFiltrados() {
      return this.serviciosDiarios.filter(s => s.tipo === 'externo');
    },

    serviciosFiltrados() {
      if (this.filtroEstadoServicios === 'todos') {
        return this.serviciosDiarios;
      }
      if (this.filtroEstadoServicios === 'externos') {
        return this.serviciosExternosFiltrados;
      }
      const esCompletado = this.filtroEstadoServicios === 'completado';
      return this.serviciosDiarios.filter(s => s.estadoCompletado === esCompletado);
    },

    serviciosCompletados() {
      return this.serviciosDiarios.filter(s => s.estadoCompletado);
    },

    serviciosPendientes() {
      return this.serviciosDiarios.filter(s => !s.estadoCompletado);
    },

    serviciosPaginados() {
      const inicio = (this.paginaActual - 1) * this.itemsPorPagina;
      return this.serviciosFiltrados.slice(inicio, inicio + this.itemsPorPagina);
    },

    totalPaginas() {
      return Math.ceil(this.serviciosFiltrados.length / this.itemsPorPagina);
    },

    totalServiciosCobrado() {
      return this.serviciosDiarios.reduce((sum, s) => sum + (s.montoCobradoUsd || 0), 0);
    },

    chartSeriesServicios() {
      const labels = [
        'Efectivo Bs',
        'Efectivo USD',
        'Pago Móvil',
        'Punto de Venta',
        'Transferencia Bs',
        'Transferencia USD',
        'Crédito Cashea',
        'Crédito Empresarial'
      ];
      const data = labels.map(label => {
        const usdVal = this.metodosServicios[label] || 0;
        if (this.monedaActiva === 'USD') {
          return parseFloat(usdVal.toFixed(2));
        } else {
          const bsVal = this.tasaUbcv ? usdVal * this.tasaUbcv : 0;
          return parseFloat(bsVal.toFixed(2));
        }
      });
      return [{
        name: 'Servicios Taller',
        data: data
      }];
    },
    
    chartOptionsServicios() {
      const isDark = document.documentElement.classList.contains('dark');
      const isBs = this.monedaActiva === 'BS';
      return {
        chart: {
          id: 'chart-servicios-taller',
          type: 'bar',
          toolbar: { show: false },
          background: 'transparent',
          animations: {
            enabled: false
          }
        },
        plotOptions: {
          bar: {
            distributed: true,
            borderRadius: 6,
            columnWidth: '50%',
            dataLabels: { position: 'top' }
          }
        },
        colors: [
          '#10B981',
          '#059669',
          '#0EA5E9',
          '#3B82F6',
          '#6366F1',
          '#4F46E5',
          '#8B5CF6',
          '#F97316'
        ],
        dataLabels: {
          enabled: true,
          formatter: function (val) {
            if (val === 0) return '';
            return isBs ? `Bs.${val.toFixed(2)}` : `$${val.toFixed(2)}`;
          },
          offsetY: -20,
          style: {
            fontSize: '9px',
            fontFamily: 'Inter, sans-serif',
            fontWeight: 'bold',
            colors: [isDark ? '#E5E7EB' : '#374151']
          }
        },
        legend: { show: false },
        xaxis: {
          categories: [
            'Efectivo Bs',
            'Efectivo USD',
            'Pago Móvil',
            'Punto de Venta',
            'Transferencia Bs',
            'Transferencia USD',
            'Crédito Cashea',
            'Crédito Empresarial'
          ],
          labels: {
            style: {
              colors: isDark ? '#9CA3AF' : '#4B5563',
              fontSize: '10px',
              fontFamily: 'Inter, sans-serif',
              fontWeight: 600
            }
          }
        },
        yaxis: {
          labels: {
            style: {
              colors: isDark ? '#9CA3AF' : '#4B5563'
            },
            formatter: (value) => {
              if (isBs) return `Bs.${value.toLocaleString('es-VE')}`;
              return `$${value.toFixed(2)}`;
            }
          }
        },
        theme: {
          mode: isDark ? 'dark' : 'light'
        },
        tooltip: {
          theme: isDark ? 'dark' : 'light',
          y: {
            formatter: (value) => {
              if (isBs) return `Bs. ${value.toLocaleString('es-VE', { minimumFractionDigits: 2 })}`;
              return `$${value.toFixed(2)}`;
            }
          }
        },
        grid: {
          borderColor: isDark ? '#374151' : '#F3F4F6'
        }
      };
    },

    chartSeriesRecepcionesExpress() {
      const labels = [
        'Efectivo Bs',
        'Efectivo USD',
        'Pago Móvil',
        'Punto de Venta',
        'Transferencia Bs',
        'Transferencia USD',
        'Crédito Cashea',
        'Crédito Empresarial'
      ];
      const data = labels.map(label => {
        const usdVal = this.metodosRecepcionesExpress[label] || 0;
        if (this.monedaActiva === 'USD') {
          return parseFloat(usdVal.toFixed(2));
        } else {
          const bsVal = this.tasaUbcv ? usdVal * this.tasaUbcv : 0;
          return parseFloat(bsVal.toFixed(2));
        }
      });
      return [{
        name: 'Recepciones Express',
        data: data
      }];
    },
    
    chartOptionsRecepcionesExpress() {
      const isDark = document.documentElement.classList.contains('dark');
      const isBs = this.monedaActiva === 'BS';
      return {
        chart: {
          id: 'chart-recepciones-express',
          type: 'bar',
          toolbar: { show: false },
          background: 'transparent',
          animations: {
            enabled: false
          }
        },
        plotOptions: {
          bar: {
            distributed: true,
            borderRadius: 6,
            columnWidth: '50%',
            dataLabels: { position: 'top' }
          }
        },
        colors: [
          '#10B981',
          '#059669',
          '#0EA5E9',
          '#3B82F6',
          '#6366F1',
          '#4F46E5',
          '#8B5CF6',
          '#F97316'
        ],
        dataLabels: {
          enabled: true,
          formatter: function (val) {
            if (val === 0) return '';
            return isBs ? `Bs.${val.toFixed(2)}` : `$${val.toFixed(2)}`;
          },
          offsetY: -20,
          style: {
            fontSize: '9px',
            fontFamily: 'Inter, sans-serif',
            fontWeight: 'bold',
            colors: [isDark ? '#E5E7EB' : '#374151']
          }
        },
        legend: { show: false },
        xaxis: {
          categories: [
            'Efectivo Bs',
            'Efectivo USD',
            'Pago Móvil',
            'Punto de Venta',
            'Transferencia Bs',
            'Transferencia USD',
            'Crédito Cashea',
            'Crédito Empresarial'
          ],
          labels: {
            style: {
              colors: isDark ? '#9CA3AF' : '#4B5563',
              fontSize: '10px',
              fontFamily: 'Inter, sans-serif',
              fontWeight: 600
            }
          }
        },
        yaxis: {
          labels: {
            style: {
              colors: isDark ? '#9CA3AF' : '#4B5563'
            },
            formatter: (value) => {
              if (isBs) return `Bs.${value.toLocaleString('es-VE')}`;
              return `$${value.toFixed(2)}`;
            }
          }
        },
        theme: {
          mode: isDark ? 'dark' : 'light'
        },
        tooltip: {
          theme: isDark ? 'dark' : 'light',
          y: {
            formatter: (value) => {
              if (isBs) return `Bs. ${value.toLocaleString('es-VE', { minimumFractionDigits: 2 })}`;
              return `$${value.toFixed(2)}`;
            }
          }
        },
        grid: {
          borderColor: isDark ? '#374151' : '#F3F4F6'
        }
      };
    },

    chartSeriesServiciosExternos() {
      const labels = [
        'Efectivo Bs',
        'Efectivo USD',
        'Pago Móvil',
        'Punto de Venta',
        'Transferencia Bs',
        'Transferencia USD',
        'Crédito Cashea',
        'Crédito Empresarial'
      ];
      const data = labels.map(label => {
        const usdVal = this.metodosServiciosExternos[label] || 0;
        if (this.monedaActiva === 'USD') {
          return parseFloat(usdVal.toFixed(2));
        } else {
          const bsVal = this.tasaUbcv ? usdVal * this.tasaUbcv : 0;
          return parseFloat(bsVal.toFixed(2));
        }
      });
      return [{
        name: 'Servicios Externos',
        data: data
      }];
    },
    
    chartOptionsServiciosExternos() {
      const isDark = document.documentElement.classList.contains('dark');
      const isBs = this.monedaActiva === 'BS';
      return {
        chart: {
          id: 'chart-servicios-externos',
          type: 'bar',
          toolbar: { show: false },
          background: 'transparent',
          animations: {
            enabled: false
          }
        },
        plotOptions: {
          bar: {
            distributed: true,
            borderRadius: 6,
            columnWidth: '50%',
            dataLabels: { position: 'top' }
          }
        },
        colors: [
          '#10B981',
          '#059669',
          '#0EA5E9',
          '#3B82F6',
          '#6366F1',
          '#4F46E5',
          '#8B5CF6',
          '#F97316'
        ],
        dataLabels: {
          enabled: true,
          formatter: function (val) {
            if (val === 0) return '';
            return isBs ? `Bs.${val.toFixed(2)}` : `$${val.toFixed(2)}`;
          },
          offsetY: -20,
          style: {
            fontSize: '9px',
            fontFamily: 'Inter, sans-serif',
            fontWeight: 'bold',
            colors: [isDark ? '#E5E7EB' : '#374151']
          }
        },
        legend: { show: false },
        xaxis: {
          categories: [
            'Efectivo Bs',
            'Efectivo USD',
            'Pago Móvil',
            'Punto de Venta',
            'Transferencia Bs',
            'Transferencia USD',
            'Crédito Cashea',
            'Crédito Empresarial'
          ],
          labels: {
            style: {
              colors: isDark ? '#9CA3AF' : '#4B5563',
              fontSize: '10px',
              fontFamily: 'Inter, sans-serif',
              fontWeight: 600
            }
          }
        },
        yaxis: {
          labels: {
            style: {
              colors: isDark ? '#9CA3AF' : '#4B5563'
            },
            formatter: (value) => {
              if (isBs) return `Bs.${value.toLocaleString('es-VE')}`;
              return `$${value.toFixed(2)}`;
            }
          }
        },
        theme: {
          mode: isDark ? 'dark' : 'light'
        },
        tooltip: {
          theme: isDark ? 'dark' : 'light',
          y: {
            formatter: (value) => {
              if (isBs) return `Bs. ${value.toLocaleString('es-VE', { minimumFractionDigits: 2 })}`;
              return `$${value.toFixed(2)}`;
            }
          }
        },
        grid: {
          borderColor: isDark ? '#374151' : '#F3F4F6'
        }
      };
    },

    chartSeriesVentas() {
      const labels = [
        'Efectivo Bs',
        'Efectivo USD',
        'Pago Móvil',
        'Punto de Venta',
        'Transferencia Bs',
        'Transferencia USD',
        'Crédito Cashea',
        'Crédito Empresarial'
      ];
      const data = labels.map(label => {
        const usdVal = this.metodosVentas[label] || 0;
        if (this.monedaActiva === 'USD') {
          return parseFloat(usdVal.toFixed(2));
        } else {
          const bsVal = this.tasaUbcv ? usdVal * this.tasaUbcv : 0;
          return parseFloat(bsVal.toFixed(2));
        }
      });
      return [{
        name: 'Ventas',
        data: data
      }];
    },
    
    chartOptionsVentas() {
      const isDark = document.documentElement.classList.contains('dark');
      const isBs = this.monedaActiva === 'BS';
      return {
        chart: {
          id: 'chart-metodos-pago-ventas',
          type: 'bar',
          toolbar: { show: false },
          background: 'transparent',
          animations: {
            enabled: false
          }
        },
        plotOptions: {
          bar: {
            distributed: true,
            borderRadius: 6,
            columnWidth: '50%',
            dataLabels: { position: 'top' }
          }
        },
        colors: [
          '#10B981',
          '#059669',
          '#0EA5E9',
          '#3B82F6',
          '#6366F1',
          '#4F46E5',
          '#8B5CF6',
          '#F97316'
        ],
        dataLabels: {
          enabled: true,
          formatter: function (val) {
            if (val === 0) return '';
            return isBs ? `Bs.${val.toFixed(2)}` : `$${val.toFixed(2)}`;
          },
          offsetY: -20,
          style: {
            fontSize: '9px',
            fontFamily: 'Inter, sans-serif',
            fontWeight: 'bold',
            colors: [isDark ? '#E5E7EB' : '#374151']
          }
        },
        legend: { show: false },
        xaxis: {
          categories: [
            'Efectivo Bs',
            'Efectivo USD',
            'Pago Móvil',
            'Punto de Venta',
            'Transferencia Bs',
            'Transferencia USD',
            'Crédito Cashea',
            'Crédito Empresarial'
          ],
          labels: {
            style: {
              colors: isDark ? '#9CA3AF' : '#4B5563',
              fontSize: '10px',
              fontFamily: 'Inter, sans-serif',
              fontWeight: 600
            }
          }
        },
        yaxis: {
          labels: {
            style: {
              colors: isDark ? '#9CA3AF' : '#4B5563'
            },
            formatter: (value) => {
              if (isBs) return `Bs.${value.toLocaleString('es-VE')}`;
              return `$${value.toFixed(2)}`;
            }
          }
        },
        theme: {
          mode: isDark ? 'dark' : 'light'
        },
        tooltip: {
          theme: isDark ? 'dark' : 'light',
          y: {
            formatter: (value) => {
              if (isBs) return `Bs. ${value.toLocaleString('es-VE', { minimumFractionDigits: 2 })}`;
              return `$${value.toFixed(2)}`;
            }
          }
        },
        grid: {
          borderColor: isDark ? '#374151' : '#F3F4F6'
        }
      };
    }
  },
  async mounted() {
    await this.cargarDatosIniciales();
    await this.cargarEstadisticasPorFecha();
    
    this.$nextTick(() => {
      setTimeout(() => {
        this.mostrarGraficos = true;
        this.cargado = true;
      }, 100);
    });
  },
  methods: {
    async cargarEquiposRetrasados() {
      try {
        const res = await apiRecepcion.obtenerRecepciones();
        if (res.success) {
          const hoy = new Date();
          const hace15Dias = new Date();
          hace15Dias.setDate(hoy.getDate() - 15);
          const hace10Dias = new Date();
          hace10Dias.setDate(hoy.getDate() - 10);
          
          const reparados = res.data.filter(r => (r.nombreEstado || '').toUpperCase() === 'REPARADO' && r.fechaReparacion);
          
          this.equiposRetrasados = reparados.filter(r => new Date(r.fechaReparacion) <= hace15Dias)
            .sort((a, b) => new Date(a.fechaReparacion) - new Date(b.fechaReparacion));
            
          this.equiposPorVencer = reparados.filter(r => {
             const f = new Date(r.fechaReparacion);
             return f > hace15Dias && f <= hace10Dias;
          }).sort((a, b) => new Date(a.fechaReparacion) - new Date(b.fechaReparacion));
        }
      } catch (e) {
        console.error('Error cargando equipos retrasados:', e);
      }
    },

    notificarWhatsappRetraso(item, tipo = 'retrasado') {
      let telefono = item.telefonoCliente || item.TelefonoCliente || item.telefono || item.Telefono;
      
      if (!telefono && item.idCliente && this.clientesPhoneMap) {
        telefono = this.clientesPhoneMap.get(item.idCliente);
      }
      
      if (!telefono) {
        alert(`El cliente ${item.nombreCliente || 'desconocido'} no tiene teléfono registrado.`);
        return;
      }

      let cleanPhone = telefono.replace(/\D/g, '');
      if (cleanPhone.length === 10 && !cleanPhone.startsWith('58')) {
        cleanPhone = '58' + cleanPhone;
      } else if (cleanPhone.length === 11 && cleanPhone.startsWith('0')) {
        cleanPhone = '58' + cleanPhone.substring(1);
      } else if (cleanPhone.length === 10 && cleanPhone.startsWith('0')) {
        cleanPhone = '58' + cleanPhone.substring(1);
      }
      
      const nombreCliente = item.nombreCliente || 'Cliente';
      const equipo = item.descripcion || 'Equipo';
      const fechaObj = new Date(item.fechaReparacion);
      const fecha = fechaObj.toLocaleDateString('es-VE');
      const diasRetraso = Math.floor((new Date() - fechaObj) / (1000 * 60 * 60 * 24));
      
      let mensaje = `Hola ${nombreCliente}, le escribimos de SYSTEM JJ\n\n`;
      if (tipo === 'retrasado') {
        mensaje += `Le recordamos que su equipo (${equipo}) está REPARADO y listo para retirar desde el ${fecha} (hace ${diasRetraso} días).\n\n`;
        mensaje += `Por favor, pase por nuestra sede a retirar su equipo a la brevedad posible para evitar cargos por almacenaje.\n\n`;
      } else {
        mensaje += `Le recordamos que su equipo (${equipo}) está REPARADO desde el ${fecha} (hace ${diasRetraso} días).\n\n`;
        mensaje += `Tome en cuenta que a los 15 días la empresa no se hace responsable por el equipo. Pase a retirarlo lo antes posible.\n\n`;
      }
      
      mensaje += `Total de la reparación: $${(item.precioTotalUsd || 0).toFixed(2)}\n`;
      if (item.montoPagadoReparacionUsd > 0) {
        mensaje += `Abonado: $${item.montoPagadoReparacionUsd.toFixed(2)}\n`;
        mensaje += `Resta: $${(item.precioTotalUsd - item.montoPagadoReparacionUsd - (item.descuento || 0)).toFixed(2)}\n`;
      }
      mensaje += `\n¡Le esperamos!`;
      
      const url = `https://wa.me/${cleanPhone}?text=${encodeURIComponent(mensaje)}`;
      window.open(url, '_blank');
    },
    cambiarFecha(delta) {
      if (!this.fechaInput) {
        this.fechaInput = new Date().toLocaleDateString('sv-SE');
      }
      const partes = this.fechaInput.split('-');
      const d = new Date(partes[0], partes[1] - 1, partes[2]);
      d.setDate(d.getDate() + delta);
      
      const hoy = new Date();
      if (d > hoy) {
        d.setTime(hoy.getTime());
      }
      
      this.fechaInput = d.toLocaleDateString('sv-SE');
      this.cargarEstadisticasPorFecha();
    },

    cambiarFechaDesdeInput() {
      if (this.fechaInput) {
        const hoy = new Date().toLocaleDateString('sv-SE');
        if (this.fechaInput > hoy) {
          this.fechaInput = hoy;
        }
        this.cargarEstadisticasPorFecha();
      }
    },

    resetearFechaHoy() {
      this.fechaInput = new Date().toLocaleDateString('sv-SE');
      this.cargarEstadisticasPorFecha();
    },

    // 👈 Helper para saber si la venta es de hoy
    fVentaEsHoy(v, fechaStr) {
      const fVenta = v.fechaVenta || v.fecha_venta || '';
      return fVenta.startsWith(fechaStr);
    },

    async cargarEstadisticasPorFecha() {
      if (!this.fechaInput) {
        this.fechaInput = new Date().toLocaleDateString('sv-SE');
      }
      
      this.cargandoStats = true;
      const fechaStr = this.fechaStr;
      
      try {
        this.resetMetodos();

        const [
          resVentas,
          resServicios,
          resPagosServ,
          resServiciosExt
        ] = await Promise.all([
          obtenerVentas(),
          apiRecepcion.obtenerRecepciones(),
          obtenerPagosSalidaEquipo(),
          apiServiciosExternos.obtenerServicios()
        ]);

        // --- PROCESAR VENTAS POR FECHA ---
        if (resVentas.success) {
          const todasVentas = resVentas.data || [];
          this.ventasOriginales = todasVentas;
          
          // 👈 PRIMERO: Cargar pagos de TODAS las ventas para saber cuáles tienen pagos HOY
          const pagosVentasMap = new Map();
          const BATCH_PRE = 30;
          for (let i = 0; i < todasVentas.length; i += BATCH_PRE) {
            const batchPre = todasVentas.slice(i, i + BATCH_PRE);
            const pagosPre = await Promise.all(batchPre.map(v => obtenerPagosPorVenta(v.idVenta)));
            batchPre.forEach((v, idx) => {
              const data = (pagosPre[idx].success && pagosPre[idx].data) ? pagosPre[idx].data : [];
              pagosVentasMap.set(v.idVenta, data);
            });
          }

          // 👈 FILTRO: ventas con fechaVenta HOY O con pagos HOY O con cuotas pagadas HOY
          const ventasFecha = todasVentas.filter(v => {
            // 1. Venta con fechaVenta HOY
            const fVenta = v.fechaVenta || v.fecha_venta || '';
            if (fVenta.startsWith(fechaStr)) return true;
            
            // 2. Venta con pagos HOY
            const pagosV = pagosVentasMap.get(v.idVenta) || [];
            const tienePagosHoy = pagosV.some(p => {
              const fPago = p.fechaPago || p.fecha_pago || '';
              return fPago.startsWith(fechaStr);
            });
            if (tienePagosHoy) return true;
            
            // 3. Venta con cuotas pagadas HOY
            const cuotas = v.cuotas || v.cuotasCredito || v.pagosCuotas || [];
            const tieneCuotasHoy = cuotas.some(c => {
              const fPagoCuota = c.fechaPago || c.fecha_pago || '';
              return fPagoCuota.startsWith(fechaStr);
            });
            if (tieneCuotasHoy) return true;
            
            return false;
          });

          let totalVentas = 0;
          let conteoVentas = ventasFecha.length;

          // 👈 Usar los pagos ya cargados del mapa
          for (const v of ventasFecha) {
            const pagosData = pagosVentasMap.get(v.idVenta) || [];
            
            // 👈 Cobrado = solo los pagos de HOY
            const pagosHoy = pagosData.filter(p => {
              const fPago = p.fechaPago || p.fecha_pago || '';
              return fPago.startsWith(fechaStr);
            });
            
            let cobrado = pagosHoy.reduce((sum, p) => sum + (parseFloat(p.montoUsd || p.monto_usd) || 0), 0);
            
            // Si no hay pagos hoy y la venta no es de hoy, no sumar nada (saltar)
            if (pagosHoy.length === 0 && !this.fVentaEsHoy(v, fechaStr)) {
              continue;
            }
            
            // Si la venta es de HOY y no tiene pagos registrados, usar el total
            if (pagosHoy.length === 0 && this.fVentaEsHoy(v, fechaStr)) {
              cobrado = parseFloat(v.totalUsd || v.total_usd || 0);
            }
            
            v.cobradoHoy = cobrado;
            totalVentas += cobrado;

            const vTipo = (v.tipoVenta || '').toUpperCase();
            const idC = (v.idTipoCredito || '').toString().toUpperCase();
            
            if (vTipo.includes('CREDITO') || vTipo.includes('CRÉDITO')) {
              let abonosUSD = 0;
              pagosHoy.forEach(p => {
                const mVal = parseFloat(p.montoUsd || p.monto_usd) || 0;
                const cat = this.clasificarPago(p.tipoPago || p.metodo_pago, p.moneda || p.moneda_original, mVal);
                this.metodosVentas[cat] += mVal;
                abonosUSD += mVal;
              });

              // 👈 Financiado: solo si la venta es de HOY
              if (this.fVentaEsHoy(v, fechaStr)) {
                const totalVenta = parseFloat(v.totalUsd || v.total_usd || 0);
                const financiado = Math.max(0, totalVenta - abonosUSD);
                const creditLabel = idC.includes('CAS') || idC.includes('CACHEA') ? 'Crédito Cashea' : 'Crédito Empresarial';
                this.metodosVentas[creditLabel] += financiado;
              }
            } else {
              if (pagosHoy.length > 0) {
                pagosHoy.forEach(p => {
                  const mVal = parseFloat(p.montoUsd || p.monto_usd) || 0;
                  const cat = this.clasificarPago(p.tipoPago || p.metodo_pago, p.moneda || p.moneda_original, mVal);
                  this.metodosVentas[cat] += mVal;
                });
              } else if (this.fVentaEsHoy(v, fechaStr)) {
                const mVal = parseFloat(v.totalUsd || v.total_usd || 0);
                const cat = this.clasificarPago(v.metodoPago || 'efectivo', 'USD', mVal);
                this.metodosVentas[cat] += mVal;
              }
            }
          }
          
          this.statsHoy.ventas = totalVentas;
          this.statsHoy.conteo += conteoVentas;
        }

        // --- PROCESAR SERVICIOS TALLER POR FECHA ---
        if (resServicios.success) {
          this.serviciosOriginales = resServicios.data || [];
          this.pagosServicios = resPagosServ.success ? (resPagosServ.data || []) : [];
          
          let totalServicios = 0;
          let conteoServicios = 0;
          
          const pagosMap = new Map();
          for (const p of this.pagosServicios) {
            const key = p.idRecepcionEquipo || p.id_recepcion_equipo || p.idRecepcion;
            if (key) {
              if (!pagosMap.has(key)) pagosMap.set(key, []);
              pagosMap.get(key).push(p);
            }
          }

          // 👇 FILTRO CORREGIDO: incluye servicios con fecha hoy, con pagos hoy, O con cuotas pagadas hoy
          const serviciosFecha = this.serviciosOriginales.filter(s => {
            // 1. Servicio con fecha de pago/entrega hoy
            const fechaRef = s.fechaPago || s.fechaEntrega || '';
            if (fechaRef.startsWith(fechaStr)) return true;
            
            // 2. Servicio con pagos (pagosServicios) de hoy
            const key = s.idRecepcionEquipo ?? s.id_recepcion_equipo ?? s.idRecepcion ?? s.id;
            const pagos = key ? pagosMap.get(key) || [] : [];
            const tienePagosHoy = pagos.some(p => {
              const fPago = p.fechaPago || p.fecha_pago || '';
              return fPago.startsWith(fechaStr);
            });
            if (tienePagosHoy) return true;
            
            // 3. Servicio con cuotas de crédito pagadas hoy
            const creditos = s.creditos || s.cuotas || s.creditosSalidaEquipo || s.cuotasCredito || [];
            const tieneCuotasPagadasHoy = creditos.some(c => {
              const fPagoCuota = c.fechaPago || c.fecha_pago || '';
              return fPagoCuota.startsWith(fechaStr);
            });
            if (tieneCuotasPagadasHoy) return true;
            
            return false;
          });

          for (const s of serviciosFecha) {
            const pagos = pagosMap.get(s.idRecepcionEquipo ?? s.id_recepcion_equipo ?? s.idRecepcion ?? s.id) || [];
            const pagosFecha = pagos.filter(p => {
              const fPago = p.fechaPago || p.fecha_pago || '';
              return fPago.startsWith(fechaStr);
            });

            // 👈 NUEVO: Sumar también las cuotas de crédito pagadas hoy
            const creditos = s.creditos || s.cuotas || s.creditosSalidaEquipo || s.cuotasCredito || [];
            const cuotasPagadasHoy = creditos.filter(c => {
              const fPagoCuota = c.fechaPago || c.fecha_pago || '';
              return fPagoCuota.startsWith(fechaStr);
            });

            const met = (s.metodoPago || '').toUpperCase();
            const esCredito = met.includes('CREDITO') || met.includes('CACHEA');
            const esCashea = met.includes('CACHEA');
            const esEmpresarial = met.includes('EMPRESA') || met.includes('EMPRESARIAL') || met.includes('CORPORATIVO');

            let cobrado = pagosFecha.reduce((sum, p) => sum + (parseFloat(p.montoUsd || p.monto_usd) || 0), 0);
            cobrado += cuotasPagadasHoy.reduce((sum, c) => {
              return sum + (parseFloat(c.montoUsd || c.monto_usd || c.montoPagoUsd || c.monto_pago_usd || 0) || 0);
            }, 0);
            
            const esExpress = (s.tipoDiagnostico || s.TipoDiagnostico || '').toString().toUpperCase().includes('EXPRESS');
            let diagnostico = parseFloat(s.montoPagadoDiagnosticoUsd || s.MontoPagadoDiagnosticoUsd || 0);
            if (!diagnostico && esExpress && pagosFecha.length === 0 && cuotasPagadasHoy.length === 0) {
              diagnostico = 10;
            }
            if ((pagosFecha.length > 0 || cuotasPagadasHoy.length > 0) && diagnostico > 0) {
              diagnostico = 0;
            }
            
            let financiado = 0;
            
            if (esCredito) {
              const totalReparacion = parseFloat(s.precioTotalUsd || s.montoCobradoUsd || 0);
              
              if (esCashea) {
                financiado = Math.max(0, totalReparacion - cobrado);
                if (financiado > 0) {
                  this.metodosServicios['Crédito Cashea'] += financiado;
                }
              } else if (esEmpresarial) {
                financiado = Math.max(0, totalReparacion - cobrado);
                if (financiado > 0) {
                  this.metodosServicios['Crédito Empresarial'] += financiado;
                }
              }
            }

            totalServicios += (cobrado + diagnostico);
            conteoServicios++;

            // Procesar pagos normales
            if (pagosFecha.length > 0) {
              pagosFecha.forEach(p => {
                const mVal = parseFloat(p.montoUsd || p.monto_usd) || 0;
                if (mVal > 0) {
                  const cat = this.clasificarPago(p.metodoPago || p.tipoPago, p.moneda || 'USD', mVal);
                  if (!cat.toLowerCase().includes('crédito')) {
                    this.metodosServicios[cat] += mVal;
                  }
                }
              });
            }
            
            // 👈 Procesar cuotas de crédito pagadas hoy
            if (cuotasPagadasHoy.length > 0) {
              cuotasPagadasHoy.forEach(c => {
                const mVal = parseFloat(c.montoUsd || c.monto_usd || c.montoPagoUsd || c.monto_pago_usd || 0) || 0;
                if (mVal > 0) {
                  const cat = this.clasificarPago(c.metodoPago || c.tipoPago || 'Efectivo', c.moneda || 'USD', mVal);
                  if (!cat.toLowerCase().includes('crédito')) {
                    this.metodosServicios[cat] += mVal;
                  }
                }
              });
            }
            
            if (pagosFecha.length === 0 && cuotasPagadasHoy.length === 0 && diagnostico > 0) {
              this.metodosServicios['Efectivo USD'] += diagnostico;
            } else if (pagosFecha.length === 0 && cuotasPagadasHoy.length === 0 && !esCredito) {
              const mVal = parseFloat(s.montoCobradoUsd || s.precioTotalUsd || 0);
              const cat = this.clasificarPago(s.metodoPago || s.metodoPagoDisplay, 'USD', mVal);
              if (!cat.toLowerCase().includes('crédito')) {
                this.metodosServicios[cat] += mVal;
              }
            }
          }

          try {
            const fechaConsulta = this.fechaInput || new Date().toLocaleDateString('sv-SE');
            const resMin = await obtenerFinanciadoEquiposMinimo(fechaConsulta);
            if (resMin) {
              const dataMin = resMin.data || resMin;
              const montoCasheaMin = this.parseMontoFinanciado(dataMin.total);
              if (montoCasheaMin > 0) {
                this.metodosServicios['Crédito Cashea'] = montoCasheaMin;
              }
            }
          } catch (e) {
            console.error('Error al obtener financiado de equipos:', e);
          }

          this.statsHoy.servicios = totalServicios;
          this.statsHoy.conteo += conteoServicios;

          // --- PROCESAR RECEPCIONES EXPRESS ---
          const recepcionesExpressFecha = this.serviciosOriginales.filter(s => {
            const esExpress = (s.tipoDiagnostico || s.TipoDiagnostico || '').toString().toUpperCase().includes('EXPRESS');
            if (!esExpress) return false;
            
            const fechaIngreso = s.fechaIngreso || s.FechaIngreso || '';
            const fechaPago = s.fechaPago || s.FechaPago || '';
            const montoDiagnostico = parseFloat(s.montoPagadoDiagnosticoUsd || s.MontoPagadoDiagnosticoUsd || 0);
            
            let fechaReferencia = fechaIngreso;
            if (montoDiagnostico > 0) {
              fechaReferencia = fechaPago || fechaIngreso;
            }
            
            return fechaReferencia.startsWith(fechaStr);
          });

          let totalRecepcionesExpress = 0;
          let conteoRecepcionesExpress = recepcionesExpressFecha.length;

          for (const s of recepcionesExpressFecha) {
            const pagos = pagosMap.get(s.idRecepcionEquipo || s.id_recepcion_equipo || s.id) || [];
            const pagosFecha = pagos.filter(p => {
              const fPago = p.fechaPago || p.fecha_pago || '';
              return fPago.startsWith(fechaStr);
            });

            let cobrado = 0;
            
            if (pagosFecha.length > 0) {
              cobrado = pagosFecha.reduce((sum, p) => sum + (parseFloat(p.montoUsd || p.monto_usd) || 0), 0);
            }
            
            if (cobrado === 0) {
              cobrado = parseFloat(s.montoPagadoDiagnosticoUsd || s.MontoPagadoDiagnosticoUsd || 0);
            }
            
            if (cobrado === 0) {
              cobrado = 10;
            }
            
            totalRecepcionesExpress += cobrado;

            if (pagosFecha.length > 0) {
              pagosFecha.forEach(p => {
                const mVal = parseFloat(p.montoUsd || p.monto_usd) || 0;
                const cat = this.clasificarPago(p.metodoPago || p.tipoPago, p.moneda || 'USD', mVal);
                if (!cat.toLowerCase().includes('crédito')) {
                  this.metodosRecepcionesExpress[cat] += mVal;
                }
              });
            } else {
              this.metodosRecepcionesExpress['Efectivo USD'] += cobrado;
            }
          }

          this.statsHoy.recepcionesExpress = totalRecepcionesExpress;
          this.statsHoy.conteo += conteoRecepcionesExpress;
        }

        // --- PROCESAR SERVICIOS EXTERNOS POR FECHA ---
        if (resServiciosExt.success) {
          const todosServicios = resServiciosExt.data || [];
          this.serviciosExternosOriginales = todosServicios;
          
          const serviciosExtFecha = todosServicios.filter(s => {
            const fechaPago = s.fechaPago || '';
            const fechaCompletado = s.fechaFinalizacion || '';
            return fechaPago.startsWith(fechaStr) || fechaCompletado.startsWith(fechaStr);
          });

          let totalServiciosExternos = 0;
          let conteoServiciosExt = serviciosExtFecha.length;

          for (const s of serviciosExtFecha) {
            const monto = parseFloat(s.montoPagado || s.costo || 0);
            
            const metodo = (s.metodoPago || 'EFECTIVO').toString().toUpperCase();
            const esCreditoEmpresarial = metodo.includes('EMPRESA') || 
                                        metodo.includes('EMPRESARIAL') || 
                                        metodo.includes('CORPORATIVO') ||
                                        metodo.includes('CREDITO') ||
                                        metodo.includes('CACHEA');
            
            if (esCreditoEmpresarial) {
              const esCashea = metodo.includes('CACHEA');
              const esEmpresarial = metodo.includes('EMPRESA') || metodo.includes('EMPRESARIAL') || metodo.includes('CORPORATIVO');
              
              if (esCashea) {
                this.metodosServiciosExternos['Crédito Cashea'] += monto;
              } else if (esEmpresarial) {
                this.metodosServiciosExternos['Crédito Empresarial'] += monto;
              } else {
                this.metodosServiciosExternos['Crédito Empresarial'] += monto;
              }
            } else {
              totalServiciosExternos += monto;
              const cat = this.clasificarPago(metodo, 'USD', monto);
              this.metodosServiciosExternos[cat] += monto;
            }
          }

          this.statsHoy.serviciosExternos = totalServiciosExternos;
          this.statsHoy.conteo += conteoServiciosExt;
        }

        this.cacheTimestamp = Date.now();

      } catch (error) {
        console.error("Error cargando estadísticas:", error);
      } finally {
        await this.verificarRecordatorioCashea();
        this.cargandoStats = false;
      }
    },

    async cargarEstadisticasHoy() {
      await this.cargarEstadisticasPorFecha();
    },

    async verificarRecordatorioCashea() {
      const hoy = new Date();
      this.esMiercoles = hoy.getDay() === 3; // 3 = Miércoles
      if (!this.esMiercoles) return;

      const hoyStr = hoy.toLocaleDateString('sv-SE');
      const lastDismissed = localStorage.getItem('casheaModalDismissed');

      const miercolesPasado = new Date(hoy);
      miercolesPasado.setDate(hoy.getDate() - 7);
      const martesAyer = new Date(hoy);
      martesAyer.setDate(hoy.getDate() - 1);

      const fromStr = miercolesPasado.toLocaleDateString('sv-SE');
      const toStr = martesAyer.toLocaleDateString('sv-SE');

      this.fechasCasheaSemanal = `Del ${miercolesPasado.toLocaleDateString('es-VE')} al ${martesAyer.toLocaleDateString('es-VE')}`;

      let totalCashea = 0;

      // Servicios
      try {
        let fechaActual = new Date(miercolesPasado);
        while (fechaActual <= martesAyer) {
          const fStr = fechaActual.toLocaleDateString('sv-SE');
          const resMin = await obtenerFinanciadoEquiposMinimo(fStr);
          if (resMin) {
            const dataMin = resMin.data || resMin;
            const montoCasheaMin = this.parseMontoFinanciado(dataMin.total);
            if (montoCasheaMin > 0) totalCashea += montoCasheaMin;
          }
          fechaActual.setDate(fechaActual.getDate() + 1);
        }
      } catch (e) {
        console.error("Error sumando cashea servicios:", e);
      }

      // Ventas
      if (this.ventasOriginales) {
        const ventasCashea = this.ventasOriginales.filter(v => {
          const fVenta = v.fechaVenta || v.fecha_venta || '';
          const f = fVenta.split('T')[0];
          const vTipo = (v.tipoVenta || '').toUpperCase();
          const idC = (v.idTipoCredito || '').toString().toUpperCase();
          return f >= fromStr && f <= toStr && (vTipo.includes('CREDITO') || vTipo.includes('CRÉDITO')) && (idC.includes('CAS') || idC.includes('CACHEA'));
        });

        for (const v of ventasCashea) {
           const totalVenta = parseFloat(v.totalUsd || v.total_usd || 0);
           const f = (v.fechaVenta || v.fecha_venta || '').split('T')[0];
           let abonosUSD = 0;
           try {
             const resPagos = await obtenerPagosPorVenta(v.idVenta || v.id_venta);
             if (resPagos.success && resPagos.data) {
               resPagos.data.forEach(p => {
                 const fPago = (p.fechaPago || p.fecha_pago || '').split('T')[0];
                 if (fPago === f) {
                   abonosUSD += parseFloat(p.montoUsd || p.monto_usd) || 0;
                 }
               });
             }
           } catch(e) {}
           const financiado = Math.max(0, totalVenta - abonosUSD);
           totalCashea += financiado;
        }
      }

      // Servicios Externos
      if (this.serviciosExternosOriginales) {
         this.serviciosExternosOriginales.forEach(s => {
           const f = (s.fechaCreacion || s.fechaRegistro || '').split('T')[0];
           if (f >= fromStr && f <= toStr) {
             const met = (s.metodoPago || '').toUpperCase();
             if (met.includes('CACHEA') || met.includes('CASHEA')) {
               totalCashea += parseFloat(s.montoUsd || s.precioTotalUsd || s.montoTotal || 0);
             }
           }
         });
      }

      this.montoCasheaSemanal = totalCashea;
      
      if (lastDismissed !== hoyStr) {
        this.mostrarModalCasheaSemanal = true;
      }
    },

    cerrarModalCashea() {
      this.mostrarModalCasheaSemanal = false;
      const hoy = new Date().toLocaleDateString('sv-SE');
      localStorage.setItem('casheaModalDismissed', hoy);
    },

    abrirModalCasheaManual() {
       this.mostrarModalCasheaSemanal = true;
    },

    formatFecha(fecha) {
      if (!fecha) return '—';
      const d = new Date(fecha);
      return d.toLocaleDateString('es-VE', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' });
    },

    formatFechaHora(fecha) {
      if (!fecha) return '';
      const d = new Date(fecha);
      return d.toLocaleTimeString('es-VE', { hour: '2-digit', minute: '2-digit' });
    },

    async cargarDatosIniciales() {
      try {
        await Promise.all([
          this.cargarClientes(),
          this.cargarTasaUbcv(),
          this.cargarEquiposRetrasados()
        ]);
      } catch (error) {
        console.error('Error cargando datos iniciales:', error);
      }
    },

    resetMetodos() {
      const resetObj = {
        'Efectivo Bs': 0,
        'Efectivo USD': 0,
        'Pago Móvil': 0,
        'Punto de Venta': 0,
        'Transferencia Bs': 0,
        'Transferencia USD': 0,
        'Crédito Cashea': 0,
        'Crédito Empresarial': 0
      };
      this.metodosServicios = { ...resetObj };
      this.metodosRecepcionesExpress = { ...resetObj };
      this.metodosServiciosExternos = { ...resetObj };
      this.metodosVentas = { ...resetObj };
    },

    async imprimirGeneral() {
      const fechaStr = this.fechaStr;

      const ventasReporte = this.ventasOriginales.filter(v => {
        const fVenta = v.fechaVenta || v.fecha_venta || '';
        return fVenta.startsWith(fechaStr);
      }).map(v => ({
        ...v,
        cobradoHoy: v.cobradoHoy !== undefined ? v.cobradoHoy : parseFloat(v.totalUsd || v.total_usd || 0)
      }));

      const serviciosReporte = this.serviciosDiarios.filter(s => s.tipo === 'interno').map(s => ({
        ...s._original,
        montoCobradoUsd: s.montoCobradoUsd
      }));

      const serviciosExternosReporte = this.serviciosDiarios.filter(s => s.tipo === 'externo').map(s => ({
        ...s._original,
        montoCobradoUsd: s.montoCobradoUsd
      }));

      const recepcionesExpressReporte = this.serviciosOriginales.filter(s => {
        const esExpress = (s.tipoDiagnostico || s.TipoDiagnostico || '').toString().toUpperCase().includes('EXPRESS');
        if (!esExpress) return false;
        
        const fechaIngreso = s.fechaIngreso || s.FechaIngreso || '';
        const fechaPago = s.fechaPago || s.FechaPago || '';
        const montoDiagnostico = parseFloat(s.montoPagadoDiagnosticoUsd || s.MontoPagadoDiagnosticoUsd || 0);
        
        let fechaReferencia = fechaIngreso;
        if (montoDiagnostico > 0) {
          fechaReferencia = fechaPago || fechaIngreso;
        }
        
        return fechaReferencia.startsWith(fechaStr);
      }).map(s => {
        return {
          ...s,
          montoCobradoUsd: 10
        };
      });

      await imprimirReporteConsolidado({
        ventas: ventasReporte,
        servicios: serviciosReporte,
        recepcionesExpress: recepcionesExpressReporte,
        serviciosExternos: serviciosExternosReporte,
        fecha: fechaStr,
        stats: this.statsHoy
      });
    },

    async cargarClientes() {
      try {
        const res = await obtenerClientes();
        if (res.success && res.data) {
          res.data.forEach(c => {
            const nombreCompleto = `${c.nombre} ${c.apellido || ''}`.trim();
            this.clientesMap.set(c.idCliente, nombreCompleto);
            this.clientesPhoneMap.set(c.idCliente, c.telefono || c.Telefono);
          });
        }
      } catch (e) {
        console.error("Error cargando clientes:", e);
      }
    },

    async cargarTasaUbcv() {
      try {
        const res = await obtenerTasaVentaActual();
        if (res.success && res.data && res.data.precio_usd_bs) {
          this.tasaUbcv = parseFloat(res.data.precio_usd_bs);
        } else {
          this.tasaUbcv = null;
        }
      } catch (e) {
        console.error('Error cargando tasa Ubcv', e);
        this.tasaUbcv = null;
      }
    },

    clasificarPago(metodo, moneda, monto) {
      const m = (metodo || '').toString().toLowerCase();
      const curr = (moneda || '').toString().toUpperCase();

      if (m.includes('cashea') || m.includes('cachea')) return 'Crédito Cashea';
      if (m.includes('empresa') || m.includes('empresarial') || m.includes('corporativo')) return 'Crédito Empresarial';
      if (m.includes('movil') || m.includes('móvil') || m.includes('pago m')) return 'Pago Móvil';
      if (m.includes('punto') || m.includes('debito') || m.includes('débito')) return 'Punto de Venta';
      if (m.includes('transferencia') || m.includes('zelle') || m.includes('bank')) {
        if (curr === 'BS' || curr === 'VES' || m.includes('bs') || m.includes('bolivar')) {
          return 'Transferencia Bs';
        }
        return 'Transferencia USD';
      }
      if (m.includes('efectivo') || m.includes('cash')) {
        if (curr === 'BS' || curr === 'VES' || m.includes('bs') || m.includes('bolivar')) {
          return 'Efectivo Bs';
        }
        return 'Efectivo USD';
      }

      if (curr === 'BS' || curr === 'VES') return 'Efectivo Bs';
      return 'Efectivo USD';
    },

    getBadgeStyle(label) {
      if (label.includes('Efectivo Bs')) return 'bg-emerald-100 text-emerald-600 dark:bg-emerald-900/30 dark:text-emerald-400';
      if (label.includes('Efectivo USD')) return 'bg-green-100 text-green-600 dark:bg-green-900/30 dark:text-green-400';
      if (label.includes('Pago Móvil')) return 'bg-sky-100 text-sky-600 dark:bg-sky-900/30 dark:text-sky-400';
      if (label.includes('Punto de Venta')) return 'bg-blue-100 text-blue-600 dark:bg-blue-900/30 dark:text-blue-400';
      if (label.includes('Transferencia Bs')) return 'bg-indigo-100 text-indigo-600 dark:bg-indigo-900/30 dark:text-indigo-400';
      if (label.includes('Transferencia USD')) return 'bg-indigo-200 text-indigo-700 dark:bg-indigo-800/30 dark:text-indigo-300';
      if (label.includes('Cashea')) return 'bg-violet-100 text-violet-600 dark:bg-violet-900/30 dark:text-violet-400 font-bold';
      if (label.includes('Empresarial')) return 'bg-orange-100 text-orange-600 dark:bg-orange-900/30 dark:text-orange-400';
      return 'bg-gray-100 text-gray-600';
    },

    getIconStyle(label) {
      if (label.includes('Efectivo')) return 'mdi:cash';
      if (label.includes('Pago Móvil')) return 'mdi:cellphone';
      if (label.includes('Punto')) return 'mdi:credit-card-outline';
      if (label.includes('Transferencia')) return 'mdi:bank-transfer';
      if (label.includes('Cashea')) return 'mdi:lightning-bolt';
      if (label.includes('Empresarial')) return 'mdi:domain';
      return 'mdi:cash-multiple';
    },

    getMetodoPagoClass(metodo) {
      if (!metodo) return 'bg-gray-100 text-gray-600 dark:bg-gray-700 dark:text-gray-300';
      const m = metodo.toLowerCase();
      if (m.includes('efectivo')) return 'bg-emerald-100 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-400';
      if (m.includes('transferencia')) return 'bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-400';
      if (m.includes('cashea') || m.includes('crédito')) return 'bg-violet-100 text-violet-700 dark:bg-violet-900/30 dark:text-violet-400';
      if (m.includes('pago móvil') || m.includes('pago movil')) return 'bg-sky-100 text-sky-700 dark:bg-sky-900/30 dark:text-sky-400';
      if (m.includes('punto')) return 'bg-indigo-100 text-indigo-700 dark:bg-indigo-900/30 dark:text-indigo-400';
      return 'bg-gray-100 text-gray-600 dark:bg-gray-700 dark:text-gray-300';
    },

    getEstadoClass(estado) {
      if (!estado) return 'bg-gray-100 text-gray-600 dark:bg-gray-700 dark:text-gray-300';
      const e = estado.toLowerCase();
      if (e.includes('entregado') || e.includes('completado') || e.includes('finalizado') || e.includes('cerrado')) {
        return 'bg-emerald-100 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-400';
      }
      if (e.includes('pendiente')) return 'bg-yellow-100 text-yellow-700 dark:bg-yellow-900/30 dark:text-yellow-400';
      if (e.includes('cancelado')) return 'bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-400';
      if (e.includes('proceso') || e.includes('reparacion')) {
        return 'bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-400';
      }
      return 'bg-gray-100 text-gray-600 dark:bg-gray-700 dark:text-gray-300';
    },

    parseMontoFinanciado(val) {
      if (typeof val === 'number') return val;
      if (!val) return 0;
      const str = String(val);
      const usdMatch = str.match(/\$?\s*([\d\.,]+)\s*USD/i) || str.match(/\$([\d\.,]+)/);
      if (usdMatch && usdMatch[1]) {
        let s = usdMatch[1];
        if (s.includes(',') && s.includes('.')) {
          s = s.replace(/,/g, '');
        } else if (s.includes(',')) {
          s = s.replace(',', '.');
        }
        const n = parseFloat(s);
        return isNaN(n) ? 0 : n;
      }
      const n = parseFloat(str.replace(/[^0-9.-]+/g, ''));
      return isNaN(n) ? 0 : n;
    }
  }
};
</script>

<style scoped>
.text-lexend { font-family: 'Lexend', sans-serif; }

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
}
.animate-fadeIn { animation: fadeIn 0.4s ease-out forwards; }

@keyframes fadeInUp {
  from { opacity: 0; transform: translateY(15px); }
  to { opacity: 1; transform: translateY(0); }
}
.animate-fadeInUp { animation: fadeInUp 0.4s ease-out forwards; }
.delay-100 { animation-delay: 0.1s; }

/* Estilos para el input de fecha */
input[type="date"]::-webkit-calendar-picker-indicator {
  filter: invert(0.5);
  cursor: pointer;
}
.dark input[type="date"]::-webkit-calendar-picker-indicator {
  filter: invert(0.8);
}
input[type="date"]::-webkit-datetime-edit {
  color: inherit;
}
</style>